const subscribers = {};
const trapFocusHandlers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];
  subscribers[eventName].push(callback);
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) subscribers[eventName].forEach((callback) => callback(data));
}

function createObserver(options) {
  const threshold = options.threshold ? options.threshold : 0;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });
  observer.observe(options.element);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function readCookie(name) {
  let list = [],
    data = getCookie(name);
  if (data !== null && data !== undefined && data !== '') list = data.split(' ');
  return list
}

function convertBreakpoint(breakpoint) {
  if (!breakpoint) return '';
  const bp = String(breakpoint).trim();
  if (bp.startsWith('(')) return bp;
  if (/^\\d+(\\.\\d+)?$/.test(bp)) return `(min-width: ${bp}px)`;

  let screen;
  switch (bp) {
    case 'small':
      screen = '(max-width: 749px)';
      break;
    case 'medium':
      screen = '(min-width: 750px) and (max-width: 1032px)';
      break;
    case 'large-up':
      screen = '(min-width: 1033px)';
      break;
    default:
      screen = bp; // fallback for custom tokens handled elsewhere
  }

  return screen;
}

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => document.removeEventListener('keydown', trapFocusHandlers.keydown);

  trapFocusHandlers.keydown = function (event) {
    // If not TAB key
    if (event.code.toUpperCase() !== 'TAB') return;
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
  });

  window.addEventListener('mousedown', (event) => mouseClick = true);

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function visibleMedia(media) {
  return Array.from(media).find((item) => {
    const style = window.getComputedStyle(item);
    return style.display !== 'none';
  });
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  window.addEventListener('message', (event) => {
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement;
          if (playerState === 1) {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement;
          if (video && !data.value) {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing Vimeo response:', error);
      }
    }
  });

  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused && !video.ended) {
      video.pause();
      video.classList.add('paused');
    }
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play();
      model.classList.add('paused');
    }
  });
}

function normalizeScope(scope) {
  if (!scope) return [];
  const arr = Array.isArray(scope) ? scope : [scope];
  return arr.map((item) => typeof item === 'string' ? document.querySelector(item) : item).filter((element) => element instanceof Element);
}

function playAllPausedMedia(scope = null) {
  const excludeRoots = normalizeScope(scope);
  const isExcluded = (element) => excludeRoots.length && excludeRoots.some(root => root.contains(element));
  document.querySelectorAll('.js-youtube.paused').forEach((video) => {
    if (isExcluded(video)) return;
    video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    video.classList.remove('paused');
  });

  document.querySelectorAll('.js-vimeo.paused').forEach((video) => {
    if (isExcluded(video)) return;
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  window.addEventListener('message', (event) => {
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement;
          if (playerState === 2) {
            video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            video.classList.remove('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement;
          if (video && data.value) {
            video.contentWindow.postMessage('{"method":"play"}', '*');
            video.classList.remove('paused');
          }
        }
      } catch (error) {
        console.error("Error parsing Vimeo response:", error);
      }
    }
  });

  document.querySelectorAll('video.paused').forEach((video) => {
    if (isExcluded(video)) return;
    video.play();
    video.classList.remove('paused');
  });

  document.querySelectorAll('product-model.paused').forEach((model) => {
    if (isExcluded(model)) return;
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play();
      model.classList.remove('paused');
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) return;
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

function injectHTMLWithScripts(element, html) {
  element.innerHTML = html;
  // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  element.querySelectorAll('script').forEach((oldScriptTag) => {
    const newScriptTag = document.createElement('script');
    Array.from(oldScriptTag.attributes).forEach((attribute) => newScriptTag.setAttribute(attribute.name, attribute.value));
    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
  });
}

const onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});

try {
  document.querySelector(':focus-visible');
  const options = Object.defineProperty({}, 'passive', {
    get() {
      ThemeSupportsPassive = true;
      return true;
    }
  });
} catch (error) {
  focusVisiblePolyfill();
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.shopMoney.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = number.toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    var shouldHideProvinceContainer = this.provinceContainer && this.provinceContainer.dataset.hideOnNoProvinces !== 'false';

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      if (shouldHideProvinceContainer) {
        this.provinceContainer.style.display = 'none';
      } else {
        this.provinceContainer.style.display = '';
      }
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class AlertElement extends HTMLElement {
  constructor() {
    super();
    this._hideTimer = null;
    this._remaining = 0;
    this._startedAt = 0;
  }

  static get observedAttributes() { return ['type']; }

  connectedCallback() {
    this._msgEl = this.querySelector('.form__message-text');
    this._boxEl = this.querySelector('.form__message');
    this.classList.remove('no-js-hidden');
    this._defaultDuration = parseInt(this.getAttribute('data-duration'), 10) || 5000;
    this.addEventListener('mouseenter', () => this._pauseTimer());
    this.addEventListener('mouseleave', () => this._resumeTimer());
    if (this.hasAttribute('type')) this._applyType(this.getAttribute('type'));
  }

  attributeChangedCallback(name, oldV, newV) {
    if (name === 'type' && oldV !== newV && this.isConnected) {
      this._applyType(newV, oldV);
    }
  }

  show(message, { type = null, duration = null } = {}) {
    if (typeof message === 'string') this._setMessage(message);
    if (type) this.type = type;
    this.hidden = false;
    requestAnimationFrame(() => this.setAttribute('open', ''));
    const ms = Number.isFinite(duration) ? duration : this._defaultDuration;
    this._startTimer(ms);
  }

  hide() {
    this._clearTimer();
    this.removeAttribute('open');
    const onEnd = () => {
      this.hidden = true;
      this._boxEl.removeEventListener('transitionend', onEnd);
    };
    this._boxEl.addEventListener('transitionend', onEnd);
    setTimeout(onEnd, 250);
  }

  get type() { return this.getAttribute('type') || 'info'; }
  set type(val) { if (val) this.setAttribute('type', val); }

  _setMessage(text) {
    if (this._msgEl) this._msgEl.textContent = text;
  }

  _applyType(next, prev) {
    if (!this._boxEl) return;
    if (prev) this._boxEl.classList.remove(`form__message--${prev}`);
    if (next) this._boxEl.classList.add(`form__message--${next}`);
  }

  _startTimer(ms) {
    this._clearTimer();
    if (!ms || ms <= 0) return;
    this._remaining = ms;
    this._startedAt = performance.now();
    this._hideTimer = setTimeout(() => this.hide(), this._remaining);
  }

  _pauseTimer() {
    if (!this._hideTimer) return;
    clearTimeout(this._hideTimer);
    this._hideTimer = null;
    const elapsed = performance.now() - this._startedAt;
    this._remaining = Math.max(0, this._remaining - elapsed);
  }

  _resumeTimer() {
    if (this._hideTimer || this._remaining <= 0) return;
    this._startedAt = performance.now();
    this._hideTimer = setTimeout(() => this.hide(), this._remaining);
  }

  _clearTimer() {
    if (this._hideTimer) clearTimeout(this._hideTimer);
    this._hideTimer = null;
  }
}

customElements.define('alert-element', AlertElement);

class AnchorLink extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.link = this.querySelector('a[href^="#"]') || (this.matches('a[href^="#"]') ? this : null);
    this.targetSelector = this.dataset.target || this.getAttribute('href') || this.link?.getAttribute('href');
    if (!this.targetSelector || !this.targetSelector.startsWith('#')) return;
    this.link?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.onClick);
  }

  get target() {
    return document.querySelector(this.targetSelector);
  }

  onClick(event) {
    const target = this.target;
    if (!target) return;

    event.preventDefault();
    this.updateActiveStateInList();

    const headerOffset = Number(this.dataset.offset || 0);
    const scrollToTarget = () => {
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top,
        behavior: this.dataset.behavior || 'smooth'
      });

      if (this.dataset.updateHash !== 'false') {
        history.pushState(null, '', this.targetSelector);
      }
    };

    const drawer = this.closest('side-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') {
      drawer.close();
      requestAnimationFrame(() => requestAnimationFrame(scrollToTarget));
      return;
    }

    scrollToTarget();
  }

  updateActiveStateInList() {
    const listItem = this.closest('li');
    const list = listItem?.closest('ul');
    const activeLink = this.link;
    if (!listItem || !list || !activeLink) return;

    list.querySelectorAll('a.link--active').forEach((link) => {
      link.classList.remove('link--active');
    });

    activeLink.classList.add('link--active');
  }
}

customElements.define('anchor-link', AnchorLink);

function setupTipsVideoFacades() {
  if (document.body.dataset.tipsVideoFacadeBound === 'true') return;
  document.body.dataset.tipsVideoFacadeBound = 'true';

  document.addEventListener('click', (event) => {
    const facade = event.target.closest('.tips_videoFacade');
    if (!facade) return;

    const wrapper = facade.closest('.tips_video__wrapper');
    const iframe = wrapper?.querySelector('iframe.vimeoPlayer');
    if (!iframe) return;

    facade.classList.add('remove_facade');
    setTimeout(() => {
      facade.style.display = 'none';
    }, 600);

    try {
      const iframeUrl = new URL(iframe.src, window.location.origin);
      iframeUrl.searchParams.set('autoplay', '1');
      iframeUrl.searchParams.set('muted', '0');
      iframe.src = iframeUrl.toString();
    } catch (error) {
      iframe.src = iframe.src.includes('?') ? `${iframe.src}&autoplay=1` : `${iframe.src}?autoplay=1`;
    }
  });
}

setupTipsVideoFacades();

class HoverElement extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.mutationObserver = new MutationObserver(() => this.update());
    this.mql = null;
    this._onMqlChange = null;
    this._raf = null;
    this._lastPx = null;
  }

  static get observedAttributes() {
    return ['data-breakpoint', 'data-parent', 'data-type'];
  }

  get breakpoint() {
    return this.dataset.breakpoint || null
  }

  get parentEl() {
    const sel = this.dataset.parent;
    if (!sel) return this.parentElement ?? null;
    try {
      return this.closest(sel)
    } catch {
      return this.parentElement ?? null
    }
  }

  get type() {
    return this.dataset.type || 'spacing'
  }

  connectedCallback() {
    if (this.type === 'none') return;
    this.init();
    this.resizeObserver.observe(this);
    this.mutationObserver.observe(this, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
    this.mutationObserver.disconnect();
    if (this.mql && this._onMqlChange) {
      this.mql.removeEventListener('change', this._onMqlChange);
    }
    if (this.parentEl) this.parentEl.style.removeProperty(`--hover-element-${this.type}`);
    if (this._raf) cancelAnimationFrame(this._raf);
    this._raf = null;
    this._lastPx = null;
  }

  init() {
    if (this.type === 'none') return;
    this._setupMediaQuery();
    this.update();
  }

  _scheduleUpdate() {
    if (this.type === 'none') return;
    if (this._raf) return;
    this._raf = requestAnimationFrame(() => {
      this._raf = null;
      this.update();
    });
  }

  update() {
    if (this.type === 'none') return;
    const parent = this.parentEl;
    if (!parent) return;

    const matches = this.mql ? this.mql.matches : true;
    const varName = `--hover-element-${this.type}`;

    if (!matches) {
      parent.style.removeProperty(varName);
      this._lastPx = null;
      return;
    }

    const isHidden = this.offsetParent === null && getComputedStyle(this).display === 'none';
    if (isHidden) return;
    const px = `${this.offsetHeight}px`;
    if (px !== this._lastPx) {
      parent.style.setProperty(varName, px);
      this._lastPx = px;
    }
  }


  _setupMediaQuery() {
    if (this.mql && this._onMqlChange) {
      this.mql.removeEventListener('change', this._onMqlChange);
    }

    if (!this.breakpoint) {
      this.mql = null;
      this._onMqlChange = null;
      return;
    }

    const query = typeof convertBreakpoint === 'function' ? convertBreakpoint(this.breakpoint) : this.breakpoint;
    this.mql = window.matchMedia(query);
    this._onMqlChange = () => this.update();
    this.mql.addEventListener('change', this._onMqlChange);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if (name === 'data-type') {
      if (newValue === 'none') {
        this.resizeObserver.disconnect();
        this.mutationObserver.disconnect();
        if (this.mql && this._onMqlChange) {
          this.mql.removeEventListener('change', this._onMqlChange);
          this.mql = null;
          this._onMqlChange = null;
        }
        if (this.parentEl && oldValue) {
          this.parentEl.style.removeProperty(`--hover-element-${oldValue}`);
        }
        this._lastPx = null;
        return;
      } else if (oldValue === 'none') {
        this.init();
        this.resizeObserver.observe(this);
        this.mutationObserver.observe(this, { childList: true, subtree: true, characterData: true });
      }
    }
    if (name === 'data-breakpoint') this._setupMediaQuery();
    this.update();
  }
}

customElements.define('hover-element', HoverElement);

class LinkHoverElement extends HTMLElement {
  constructor() {
    super();
    this._isActive = false;
    this._hoverOpenTimer = null;
    this._hoverCloseTimer = null;
    this._lastSlideIndex = null;

    this.mutationObserver = new MutationObserver(() => {
      if (this._isActive && this.type !== 'slideshow') this.update(true);
    });

    this.mql = null;
    this._onMqlChange = () => { if (this._isActive) this.update(true); };

    this.onPointerEnter = this.onPointerEnter.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this._deferredHydrated = false;
    this._deferObserver = null;
  }

  static get observedAttributes() {
    return [
      'data-breakpoint',
      'data-parent',
      'data-origin-image-src',
      'data-origin-image-srcset',
      'data-change-image-src',
      'data-change-image-srcset',
      'data-type',
      'data-target-id',
      'data-inspector-focus'
    ];
  }

  get breakpoint() {
    return this.dataset.breakpoint || null
  }

  get type() {
    return this.dataset.type
  }

  get parentEl() {
    const sel = this.dataset.parent;
    if (!sel) return this.parentElement ?? null;
    try {
      return this.closest(sel)
    } catch {
      return this.parentElement ?? null
    }
  }

  get targetSelector() {
    return this.dataset.targetId || ''
  }

  get originImageSrc() {
    return this.dataset.originImageSrc || ''
  }

  get originImageSrcset() {
    return this.dataset.originImageSrcset || ''
  }

  get changeImageSrc() {
    return this.dataset.changeImageSrc || ''
  }

  get changeImageSrcset() {
    return this.dataset.changeImageSrcset || ''
  }

  connectedCallback() {
    this._setupMediaQuery();
    this._setupDeferredImagePayload();
    this._preloadHoverImage();
    const target = this.parentEl || this;
    this.mutationObserver.observe(target, { childList: true, subtree: true, characterData: true });
    this.addEventListener('pointerenter', this.onPointerEnter);
    this.addEventListener('pointerleave', this.onPointerLeave);
  }

  disconnectedCallback() {
    this.mutationObserver.disconnect();
    if (this._deferObserver) this._deferObserver.disconnect();
    this._deferObserver = null;
    this.removeEventListener('pointerenter', this.onPointerEnter);
    this.removeEventListener('pointerleave', this.onPointerLeave);
    if (this.mql && this._onMqlChange) this.mql.removeEventListener('change', this._onMqlChange);
    clearTimeout(this._hoverOpenTimer);
    clearTimeout(this._hoverCloseTimer);
  }

  onPointerEnter() {
    const parent = this.parentEl;
    if (parent) {
      parent.querySelectorAll('link-hover-element').forEach((el) => {
        if (el === this) return;
        clearTimeout(el._hoverOpenTimer);
        clearTimeout(el._hoverCloseTimer);
      });
    }
    clearTimeout(this._hoverCloseTimer);
    clearTimeout(this._hoverOpenTimer);
    this._hoverOpenTimer = setTimeout(() => {
      this._isActive = true;
      this.update(true);
    }, 60);
  }

  onPointerLeave() {
    clearTimeout(this._hoverOpenTimer);
    clearTimeout(this._hoverCloseTimer);
    this._hoverCloseTimer = setTimeout(() => {
      const parent = this.parentEl;
      const hasHoveredSibling = parent
        ? Array.from(parent.querySelectorAll('link-hover-element')).some((el) => el !== this && el.matches(':hover'))
        : false;
      if (hasHoveredSibling) return;
      this._isActive = false;
      this.update(false);
    }, 150);
  }

  update(change) {
    if (typeof change !== 'boolean') return;
    const matches = this.mql ? this.mql.matches : true;
    const useHover = matches && change;

    if (!useHover && this.type === 'slideshow') {
      this._lastSlideIndex = null;
    }

    if (this.type === 'inspector') {
      this._applyInspector(useHover);
    } else if (this.type === 'slideshow') {
      this._applySlideshow(useHover);
    } else {
      this._applyImageSwap(useHover);
    }
  }

  _applyImageSwap(useHover) {
    const parent = this.parentEl;
    if (!parent) return;

    const img = parent.querySelector('.card__media .media img') || parent.querySelector('img');
    if (!img) return;

    const nextSrc = useHover ? (this.changeImageSrc || '') : (this.originImageSrc || '');
    const nextSrcset = useHover ? (this.changeImageSrcset || '') : (this.originImageSrcset || '');
    const abs = u => (u ? new URL(u, document.baseURI).href : '');
    const current = img.currentSrc || img.src || '';
    const wantAbs = abs(nextSrc);

    if (nextSrcset) {
      if (img.getAttribute('srcset') !== nextSrcset) img.setAttribute('srcset', nextSrcset);
    } else if (img.hasAttribute('srcset')) {
      img.removeAttribute('srcset');
    }

    if (nextSrc) {
      if ((img.getAttribute('src') || '') !== nextSrc && current !== wantAbs) {
        img.setAttribute('src', nextSrc);
      }
    }
  }

  _applyInspector(useHover) {
    const scope = this.parentEl || document;
    if (!this.targetSelector) return;
    let target = null;
    try {
      target = scope.querySelector(this.targetSelector);
    } catch {
      target = null;
    }
    if (!target) return;
    target.classList.toggle('active', !!useHover);
  }

  _applySlideshow(useHover) {
    if (!useHover) return;

    const scope = this.parentEl || document;
    if (!this.targetSelector) return;

    let target;

    try {
      target = scope.querySelector(this.targetSelector);
    } catch {
      return;
    }

    if (!target) return;

    const swiperEl = this.parentEl?.querySelector('[data-swiper]');
    if (!swiperEl) return;

    const slideEl = target.classList?.contains('swiper-slide')
      ? target
      : target.closest('.swiper-slide');

    const indexStr = slideEl?.dataset?.index;
    const index = Number.parseInt(indexStr, 10);
    if (Number.isNaN(index)) return;

    if (index === this._lastSlideIndex) return;
    this._lastSlideIndex = index;

    if (typeof swiperEl.setActiveSlideItem === 'function') {
      swiperEl.setActiveSlideItem(index);
    }
  }

  _setupDeferredImagePayload() {
    if (this._deferredHydrated || this.changeImageSrc) return;
    const template = this.querySelector('template[data-hover-image-template]');
    if (!template) return;

    const hydrate = () => {
      if (this._deferredHydrated) return;
      const payload = template.content?.firstElementChild;
      if (!payload) return;

      const originSrc = payload.getAttribute('data-origin-image-src');
      const originSrcset = payload.getAttribute('data-origin-image-srcset');
      const changeSrc = payload.getAttribute('data-change-image-src');
      const changeSrcset = payload.getAttribute('data-change-image-srcset');

      if (originSrc) this.dataset.originImageSrc = originSrc;
      if (originSrcset) this.dataset.originImageSrcset = originSrcset;
      if (changeSrc) this.dataset.changeImageSrc = changeSrc;
      if (changeSrcset) this.dataset.changeImageSrcset = changeSrcset;

      this._deferredHydrated = true;
      template.remove();
    };

    if (!('IntersectionObserver' in window)) {
      hydrate();
      return;
    }

    const observedSection = this.closest('.shopify-section') || this.closest('section') || this;
    this._deferObserver = new IntersectionObserver((entries, observer) => {
      const entry = entries[0];
      if (!entry || !entry.isIntersecting) return;
      hydrate();
      observer.disconnect();
      this._deferObserver = null;
    }, { rootMargin: '200px 0px' });

    this._deferObserver.observe(observedSection);
  }

  _setupMediaQuery() {
    if (this.mql && this._onMqlChange) this.mql.removeEventListener('change', this._onMqlChange);
    if (!this.breakpoint) {
      this.mql = null;
      return
    }

    const query = typeof convertBreakpoint === 'function' ? convertBreakpoint(this.breakpoint) : this.breakpoint;
    this.mql = window.matchMedia(query);
    this.mql.addEventListener('change', this._onMqlChange);
  }

  _preloadHoverImage() {
    if (this.changeImageSrc) {
      const i = new Image();
      i.decoding = 'async';
      i.src = this.changeImageSrc;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if (name === 'data-breakpoint') this._setupMediaQuery();
    if (name === 'data-change-image-src') this._preloadHoverImage();
    if (name === 'data-type' || name === 'data-target-id') {
      if (this._isActive) this.update(true);
    }
  }
}

customElements.define('link-hover-element', LinkHoverElement);

class TabHoverElement extends HTMLElement {
  constructor() {
    super();
    this._handlers = [];
  }

  get links() {
    if (!this._links) this._links = Array.from(this.querySelectorAll('[tab-hover-element-link]'));
    return this._links;
  }
  get tabs() {
    if (!this._tabs) this._tabs = Array.from(this.querySelectorAll('[tab-hover-element-tab]'));
    return this._tabs;
  }

  connectedCallback() {
    const onPointerEnter = (e) => {
      const link = e.target.closest('[tab-hover-element-link]');
      if (!link || !this.contains(link)) return;
      const tabId = link.dataset.tabId || `Tab-${link.dataset.id}`;
      this.open(link, tabId);
    };

    const onFocusIn = (e) => {
      const link = e.target.closest('[tab-hover-element-link]');
      if (!link || !this.contains(link)) return;
      const tabId = link.dataset.tabId || `Tab-${link.dataset.id}`;
      this.open(link, tabId);
    };

    const onClick = (e) => {
      const link = e.target.closest('[tab-hover-element-link]');
      if (!link || !this.contains(link)) return;
      // if (!link.getAttribute('href')) e.preventDefault();
      const tabId = link.dataset.tabId || `Tab-${link.dataset.id}`;
      this.open(link, tabId);
    };

    const onKeyDown = (e) => {
      const current = document.activeElement.closest('[tab-hover-element-link]');
      if (!current || !this.contains(current)) return;
      let idx = this.links.indexOf(current);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        idx = (idx + 1) % this.links.length;
        this.links[idx].focus();
        const tabId = this.links[idx].dataset.tabId || `Tab-${this.links[idx].dataset.id}`;
        this.open(this.links[idx], tabId);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = (idx - 1 + this.links.length) % this.links.length;
        this.links[idx].focus();
        const tabId = this.links[idx].dataset.tabId || `Tab-${this.links[idx].dataset.id}`;
        this.open(this.links[idx], tabId);
      } else if (e.key === 'Home') {
        e.preventDefault();
        this.links[0].focus();
        const tabId = this.links[0].dataset.tabId || `Tab-${this.links[0].dataset.id}`;
        this.open(this.links[0], tabId);
      } else if (e.key === 'End') {
        e.preventDefault();
        const last = this.links[this.links.length - 1];
        last.focus();
        const tabId = last.dataset.tabId || `Tab-${last.dataset.id}`;
        this.open(last, tabId);
      }
    };
    this.addEventListener('pointerenter', onPointerEnter, { capture: true });
    this.addEventListener('focusin', onFocusIn, { capture: true });
    this.addEventListener('click', onClick, { capture: true });
    this.addEventListener('keydown', onKeyDown);
    this._handlers.push(
      ['pointerenter', onPointerEnter],
      ['focusin', onFocusIn],
      ['click', onClick],
      ['keydown', onKeyDown]
    );
    this.links.forEach((link) => {
      link.setAttribute('role', link.getAttribute('role') || 'tab');
      link.setAttribute('aria-selected', link.getAttribute('aria-selected') || 'false');
      const tabId = link.dataset.tabId || `Tab-${link.dataset.id}`;
      link.setAttribute('aria-controls', tabId);
    });
    this.tabs.forEach((tab) => {
      tab.setAttribute('role', tab.getAttribute('role') || 'tabpanel');
      if (!tab.id) tab.id = tab.dataset.tabId;
      if (!tab.hasAttribute('hidden')) tab.hidden = true;
    });
    if (this.links.length && this.tabs.length && !this.querySelector('.active')) {
      const first = this.links[0];
      const tabId = first.dataset.tabId || `Tab-${first.dataset.id}`;
      this.open(first, tabId);
    }
  }

  disconnectedCallback() {
    this._handlers.forEach(([type, fn]) => this.removeEventListener(type, fn, { capture: true }));
    this._handlers = [];
  }

  open(linkEl, tabId) {
    if (!linkEl || !tabId) return;
    const tabEl = this.querySelector(`[id="${tabId}"]`);
    // if (!tabEl) return;
    if (linkEl.classList.contains('active')) return;
    this.links.forEach((l) => {
      const isActive = l === linkEl;
      l.classList.toggle('active', isActive);
      l.setAttribute('aria-selected', isActive ? 'true' : 'false');
      l.tabIndex = isActive ? 0 : -1;
    });
    this.tabs.forEach((t) => {
      const match = t === tabEl;
      t.classList.toggle('active', match);
      t.hidden = !match;
    });
  }
}

customElements.define('tab-hover-element', TabHoverElement);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.date = new Date(`${this.dataset.month}/${this.dataset.day}/${this.dataset.year} ${this.dataset.hour}:${this.dataset.minute}:00`);
    this.unit = this.dataset.dateTimeUnit;
    this.template = this.querySelector('template').content.firstElementChild.innerHTML;
    this.hideOnEnd = this.hasAttribute('hide-on-end');
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.calculate();
    this.timerInterval = setInterval(this.calculate.bind(this), 1000);
  }

  calculate() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.complete();
      return;
    }

    let content = this.template;

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;
    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
    let day_text, hour_text, min_text, sec_text;

    if (this.unit == 'short') {
      day_text = this.dataset.dayText;
      hour_text = this.dataset.hourText;
      min_text = this.dataset.minuteText;
      sec_text = this.dataset.secondText;
    } else {
      day_text = days === 1 ? this.dataset.dayText : this.dataset.daysText;
      hour_text = hours === 1 ? this.dataset.hourText : this.dataset.hoursText;
      min_text = mins === 1 ? this.dataset.minuteText : this.dataset.minutesText;
      sec_text = secs === 1 ? this.dataset.secondText : this.dataset.secondsText;
    }

    content = content.replaceAll('[days]', this.addLeadingZero(days));
    content = content.replaceAll('[hours]', this.addLeadingZero(hours));
    content = content.replaceAll('[mins]', this.addLeadingZero(mins));
    content = content.replaceAll('[secs]', this.addLeadingZero(secs));
    content = content.replaceAll('[days_text]', day_text);
    content = content.replaceAll('[hours_text]', hour_text);
    content = content.replaceAll('[mins_text]', min_text);
    content = content.replaceAll('[secs_text]', sec_text);
    const html = new DOMParser().parseFromString(content, 'text/html');
    this.innerHTML = html.body.innerHTML;
  }

  addLeadingZero(num) {
    return num < 10 ? `0${num}` : `${num}`;
  }

  complete() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    if (this.hideOnEnd) this.remove();
  }
}

customElements.define('countdown-timer', CountdownTimer);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this._open = this.details.hasAttribute('open');
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  get open() {
    return this._open
  }

  set open(value) {
    value = Boolean(value);
    if (value !== this._open) {
      this._open = value;
      if (value) {
        this.details.setAttribute('open', '');
      } else {
        this.details.removeAttribute('open');
      }
    }

    this.details.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { current: this } }));
  }

  get details() {
    return this._details || this.querySelector('details')
  }

  get summaryElement() {
    return this._summaryElement || this.querySelector('summary')
  }

  get contentElement() {
    return this._contentElement || this.querySelector('summary + *')
  }

  get state() {
    return this.details.hasAttribute('open')
  }

  get breakpoint() {
    return this.dataset.breakpoint
  }

  connectedCallback() {
    this.onInitilize();
    this.summaryElement?.addEventListener('click', this.onSummaryClick);
    this.details.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    this.summaryElement?.removeEventListener('click', this.onSummaryClick);
    this.details.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('resize', this.onResize);
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.toggle();
  }

  toggle(forceState = !this.open) {
    this.open = forceState;
  }

  openDetails() {
    this.open = true;
  }

  closeDetails() {
    this.open = false;
  }

  onInitilize() {
    this.update();
  }

  update() {
    if (this.breakpoint == 'all' || this.breakpoint === undefined) return;

    const breakpoints = String(this.breakpoint).split(',').map((breakpoint) => breakpoint.trim()).filter(Boolean);
    const matchesBreakpoint = breakpoints.some((breakpoint) => {
      const query = convertBreakpoint(breakpoint);
      return query ? window.matchMedia(query).matches : false;
    });

    if (!matchesBreakpoint) {
      this.openDetails();
    } else if (this.dataset.open === undefined) {
      this.closeDetails();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.closeDetails();
    }
  }

  onResize() {
    this.update();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class DetailsDisclosures extends HTMLElement {
  constructor() {
    super();
    this._onToggle = this._onToggle.bind(this);
  }

  connectedCallback() {
    if (!this.onlyOne && !this.onlyOneDesktop) return;
    this.enforceSingleOpen();
    this.observeDetails();
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
    if (this.observer) this.observer.disconnect();
  }

  get onlyOneDesktop() {
    return this.hasAttribute('only-one-desktop');
  }

  get isDesktop() {
    return window.matchMedia('(min-width: 1033px)').matches;
  }

  get shouldEnforceSingleOpen() {
    if (this.onlyOne) return true;

    if (this.onlyOneDesktop) {
      return this.isDesktop;
    }

    return false;
  }

  get onlyOne() {
    return this.hasAttribute('only-one');
  }

  get allDetailsDisclosure() {
    return this._allDetailsDisclosure = Array.from(this.querySelectorAll('details-disclosure'));
  }

  addEventListeners() {
    this.allDetailsDisclosure.forEach(detailsDisclosure => detailsDisclosure.addEventListener('toggle', this._onToggle));
  }

  removeEventListeners() {
    if (!this._allDetailsDisclosure) return;
    this._allDetailsDisclosure.forEach(detailsDisclosure => detailsDisclosure.removeEventListener('toggle', this._onToggle));
  }

  _onToggle(event) {


    const current = event.currentTarget;
    if (!current.open || !this.shouldEnforceSingleOpen) return;
    const anchor = current.summaryElement || current;
    const shouldUseRafClose = this.parentElement?.hasAttribute('data-collapsible-metafields');

    this.allDetailsDisclosure.forEach(detailsDisclosure => {
      if (detailsDisclosure !== current) {
        if (shouldUseRafClose) {
          requestAnimationFrame(() => detailsDisclosure.toggle(false));
        } else {
          detailsDisclosure.toggle(false);
        }
      }
    });

    if (shouldUseRafClose) {
      // Keep the tapped summary anchored in viewport on mobile after sibling panels collapse.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const endTop = anchor.getBoundingClientRect().top;
          if (Math.abs(endTop) > 1) {
            const target = window.scrollY + endTop - 100;
            const start = window.scrollY;
            const distance = target - start;
            const duration = 600;
            const startTime = performance.now();
            const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
            const step = now => {
              const elapsed = Math.min((now - startTime) / duration, 1);
              window.scrollTo(0, start + distance * easeInOutQuart(elapsed));
              if (elapsed < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }
        });
      });
    }
  }

  enforceSingleOpen() {
    if (!this.shouldEnforceSingleOpen) return;

    let firstOpenFound = false;

    this.allDetailsDisclosure.forEach(detailsDisclosure => {
      if (detailsDisclosure.open) {
        if (!firstOpenFound) {
          firstOpenFound = true;
        } else {
          detailsDisclosure.toggle(false);
        }
      }
    });
  }

  observeDetails() {
    this.observer = new MutationObserver(() => {
      this.removeEventListeners();
      this._allDetailsDisclosure = null;
      this.enforceSingleOpen();
      this.addEventListeners();
    });

    this.observer.observe(this, { childList: true, subtree: true });
  }
}

customElements.define('details-disclosures', DetailsDisclosures);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
    this.overlay?.addEventListener('click', this.onSummaryClick.bind(this));
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]')
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open')
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

class FormElement extends HTMLElement {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldInteraction = this.handleFieldInteraction.bind(this);
  }

  connectedCallback() {
    const templateForm = this.querySelector('.template-form');
    this.form = this.querySelector('form');

    if (templateForm && !this.getAttribute('loaded')) {
      this.message = templateForm.content.firstElementChild.cloneNode(true);
      this.messageContent = this.message.innerHTML || '';
      this.messageType = this.message.dataset.messageType;
      this.handleMessage();
      this.setAttribute('loaded', true);
    }

    if (!this.form || this.validationLoaded) return;
    this.form.setAttribute('novalidate', 'novalidate');
    this.form.noValidate = true;
    this.form.addEventListener('submit', this.handleSubmit, true);
    this.form.addEventListener('input', this.handleFieldInteraction);
    this.form.addEventListener('change', this.handleFieldInteraction);
    this.form.addEventListener('blur', this.handleFieldInteraction, true);
    this.validationLoaded = true;
  }

  disconnectedCallback() {
    if (!this.form) return;
    this.form.removeEventListener('submit', this.handleSubmit, true);
    this.form.removeEventListener('input', this.handleFieldInteraction);
    this.form.removeEventListener('change', this.handleFieldInteraction);
    this.form.removeEventListener('blur', this.handleFieldInteraction, true);
    this.validationLoaded = false;
  }

  handleSubmit(event) {
    if (this.isSubmitting) {
      this.isSubmitting = false;
      return;
    }

    event.preventDefault();

    if (!this.validateRequiredFields()) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      const firstInvalidField = this.form.querySelector('[aria-invalid="true"]');
      if (firstInvalidField) firstInvalidField.focus();
      return false;
    }

    this.isSubmitting = true;
    this.form.setAttribute('novalidate', 'novalidate');
    this.form.noValidate = true;
    this.form.requestSubmit(event.submitter || undefined);
    return true;
  }

  handleFieldInteraction(event) {
    const field = event.target.closest('input, select, textarea');
    if (!field || !this.form?.contains(field) || !this.isRequiredField(field)) return;
    this.validateField(field);
  }

  validateRequiredFields() {
    const requiredFields = this.getRequiredFields();
    let isFormValid = true;

    requiredFields.forEach((field) => {
      if (!this.validateField(field)) isFormValid = false;
    });

    return isFormValid
  }

  getRequiredFields() {
    if (!this.form) return [];

    const requiredFields = Array.from(this.form.querySelectorAll('input[required], select[required], textarea[required]')).filter((field) => !field.disabled);
    const groupedFieldNames = new Set();

    return requiredFields.filter((field) => {
      if (!['checkbox', 'radio'].includes(field.type)) return true;
      if (groupedFieldNames.has(field.name)) return false;
      groupedFieldNames.add(field.name);
      return true;
    });
  }

  validateField(field) {
    if (!this.isRequiredField(field)) return true;
    const isGroupedField = ['checkbox', 'radio'].includes(field.type);
    const groupFields = isGroupedField ? this.getGroupedFields(field) : [field];
    const validationTarget = groupFields[0];
    const isValid = isGroupedField ? this.isGroupedFieldValid(field) : field.checkValidity();
    const message = isValid ? '' : (validationTarget.validationMessage || 'This field is required.');

    groupFields.forEach((groupField) => {
      this.toggleFieldError(groupField, message);
    });

    return isValid
  }

  isRequiredField(field) {
    return field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement
      ? field.hasAttribute('required')
      : false;
  }

  getGroupedFields(field) {
    if (!field.name || !this.form) return [field];
    return Array.from(this.form.querySelectorAll(`[name="${CSS.escape(field.name)}"]`))
  }

  isGroupedFieldValid(field) {
    return this.getGroupedFields(field).some((groupField) => groupField.checked)
  }

  toggleFieldError(field, message = '') {
    const fieldWrapper = field.closest('.form__field');
    if (!fieldWrapper) return;
    const messageElement = this.getFieldMessageElement(field, fieldWrapper);
    const hasError = Boolean(message);
    fieldWrapper.classList.toggle('form__field--error', hasError);
    field.setAttribute('aria-invalid', String(hasError));
    if (!hasError) {
      messageElement.classList.add('hidden');
      messageElement.querySelector('.error-message').textContent = '';
      field.removeAttribute('aria-describedby');
      return;
    }

    field.setAttribute('aria-describedby', messageElement.id);
    messageElement.classList.remove('hidden');
    messageElement.querySelector('.error-message').textContent = message;
  }

  getFieldMessageElement(field, fieldWrapper) {
    const fieldId = field.id || `${field.name.replace(/[^a-zA-Z0-9_-]/g, '-')}-field`;
    const messageId = `${fieldId}-error`;
    let messageElement = fieldWrapper.querySelector(`#${CSS.escape(messageId)}`);
    if (messageElement) return messageElement;
    messageElement = document.createElement('div');
    messageElement.id = messageId;
    messageElement.className = 'form__message form__message--inline hidden';
    messageElement.innerHTML = '<small class="error-message"></small>';
    fieldWrapper.appendChild(messageElement);

    return messageElement
  }

  handleMessage() {
    switch (this.messageType) {
      case 'error':
        this.handleErrorMessage(this.messageContent);
        break;
      case 'success':
        this.handleSuccessMessage(this.messageContent);
        break;
      default:
        break;
    }
  }

  handleSuccessMessage(successMessage = false) {
    if (this.hideAlert || successMessage == false) return;
    this.successAlert = this.successAlert || this.querySelector(`[id^="Alert-Success-"]`) || document.querySelector(`[id="Alert-Success"]`);
    if (!this.successAlert) return;
    this.successAlert.show(successMessage, { type: 'success', duration: ON_VISIBLE_DEBOUNCE_TIMER });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideAlert || errorMessage == false) return;
    this.errorAlert = this.errorAlert || this.querySelector(`[id^="Alert-Error-"]`) || document.querySelector(`[id="Alert-Error"]`);
    if (!this.errorAlert) return;
    this.errorAlert.show(errorMessage, { type: 'error', duration: ON_VISIBLE_DEBOUNCE_TIMER });
  }
}

customElements.define('form-element', FormElement);

class ImageAnimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('loaded', true);
  }
}

customElements.define('image-animation', ImageAnimation);

class LoadingOverlay extends HTMLElement {
  constructor() {
    super();
  }

  enableLoading() {
    this.classList.remove('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.add('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', true);
  }
}

customElements.define('loading-overlay', LoadingOverlay);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.delay = 0;
    this.animate = false;
    this.handleResize = this.handleResize.bind(this);
    this.bindEvents();
  }

  static get observedAttributes() {
    return ['breakpoint'];
  }

  get button() {
    return this.querySelector('[id^="ModalClose-"]')
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]')
  }

  get breakpoint() {
    return this.getAttribute('breakpoint')
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => {
      if (!(event instanceof KeyboardEvent)) return;
      if (event.key === 'Escape' || event.code === 'Escape') this.hide();
    });
    this.overlay?.addEventListener('click', this.hide.bind(this, false));
    this.button?.addEventListener('click', this.hide.bind(this, false));
  }

  handleResize() {
    if (!this.breakpoint) return;
    if (!window.matchMedia(this.breakpoint).matches && this.hasAttribute('open')) {
      console.warn(`Modal hidden on resize: breakpoint "${this.breakpoint}" no longer matches.`);
      this.hide();
    }
  }

  loadContent() {
    const templatePopup = this.querySelector('.template-popup');
    if (!templatePopup) return;
    if (!this.getAttribute('loaded')) {
      templatePopup.replaceWith(templatePopup.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
    }
  }

  show(triggeredBy) {
    if (this.breakpoint && !window.matchMedia(this.breakpoint).matches) {
      console.warn('Modal display suppressed due to active breakpoint.');
      return;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.loadContent();
    setTimeout(() => {
      this.setAttribute('open', '');
      this.classList.add('animate', 'active');
      this.querySelector('.modal__content').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      document.body.classList.add('modal-show', 'overflow-hidden');
    }, this.delay);
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.removeAttribute('open');
    this.classList.remove('animate', 'active');
    document.body.classList.remove('modal-show', 'overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    removeTrapFocus(this.activeElement);
    window.pauseAllMedia();
    window.playAllPausedMedia(this);
  }

  setActiveElement(element) {
    if (!element) return;
    this.activeElement = element;
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'breakpoint' && this.hasAttribute('open')) {
      if (!window.matchMedia(newVal).matches) {
        this.hide();
      }
    }
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class MoreLessLayout extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".more-less-layout__content");
    this.button = this.querySelector("button");
    this.readMoreText = this.getAttribute("data-read-more-text") || "Read More";
    this.readLessText = this.getAttribute("data-read-less-text") || "Read Less";
    this.maxLinesDesktop = parseInt(this.getAttribute("data-max-lines-desktop"), 10) || 3;
    this.maxLinesMobile = parseInt(this.getAttribute("data-max-lines-mobile"), 10) || 2;
    this.expanded = false;
    this.updateStyles();
    this.checkButtonVisibility();
    this.button.addEventListener("click", () => this.toggleReadMore());
  }

  updateStyles() {
    this.content.style.display = "-webkit-box";
    this.content.style.overflow = "hidden";
    this.content.style.webkitBoxOrient = "vertical";
    this.content.style.webkitLineClamp = this.getMaxLines();
  }

  getMaxLines() {
    return window.matchMedia('(min-width: 1033px)').matches ? this.maxLinesDesktop : this.maxLinesMobile
  }

  toggleReadMore() {
    if (this.expanded) {
      this.content.style.display = "-webkit-box";
      this.content.style.overflow = "hidden";
      this.content.style.webkitBoxOrient = "vertical";
      this.content.style.webkitLineClamp = this.getMaxLines();
      this.button.querySelector('span:not(.icon)').textContent = this.readMoreText;
    } else {
      this.content.style.display = "block";
      this.content.style.overflow = "visible";
      this.content.style.webkitLineClamp = "unset";
      this.button.querySelector('span:not(.icon)').textContent = this.readLessText;
    }
    this.classList.toggle('expanded', !this.expanded);
    this.expanded = !this.expanded;
  }

  checkButtonVisibility() {
    const fullLines = this.getFullLineCount();
    const maxLines = this.getMaxLines();
    this.button.closest('.more-less-layout__button').classList.toggle('hidden', fullLines <= maxLines);
  }

  getFullLineCount() {
    const style = window.getComputedStyle(this.content);
    const lineHeight = parseFloat(style.lineHeight);
    const fullHeight = this.content.scrollHeight;
    return Math.round(fullHeight / lineHeight);
  }

  connectedCallback() {
    window.addEventListener('resize', () => {
      if (!this.expanded) {
        this.updateStyles();
        this.checkButtonVisibility();
      }
    });
  }
}

customElements.define('more-less-layout', MoreLessLayout);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.loaded) return;

    if (this.dataset.product === 'page-product') {
      window.setTimeout(() => {
        if (!this.loaded) this.init();
      }, 2000);
      return;
    }

    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 400
    });
  }

  init() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = this.getMatchingRecommendations(html);
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.loaded = true;
          if (this.closest('cart-notification')) {
            let cartNotification = this.closest('cart-notification');
            trapFocus(cartNotification, cartNotification.querySelector('[role="dialog"]'));
          }
        } else {
          let isHidden = this.getAttribute('data-hidden') === 'true';
          isHidden && this.remove();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getMatchingRecommendations(html) {
    const recommendations = [...html.querySelectorAll('product-recommendations')];
    if (!recommendations.length) return null;

    if (this.id) {
      const matchingById = html.getElementById(this.id);
      if (matchingById?.matches('product-recommendations')) return matchingById;
    }

    const currentUrl = this.dataset.url;
    const matchingByUrl = currentUrl ? recommendations.filter((element) => element.dataset.url === currentUrl) : [];
    if (matchingByUrl.length === 1) return matchingByUrl[0];
    if (matchingByUrl.length > 1) {
      const currentIndex = [...document.querySelectorAll('product-recommendations')].filter((element) => element.dataset.url === currentUrl).indexOf(this);
      if (currentIndex > -1 && matchingByUrl[currentIndex]) return matchingByUrl[currentIndex];
    }

    const allCurrentRecommendations = [...document.querySelectorAll('product-recommendations')];
    const currentIndex = allCurrentRecommendations.indexOf(this);

    return recommendations[currentIndex] || recommendations[0];
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class OverflowList extends HTMLElement {
  constructor() {
    super();

    this._reflowFrameId = null;
    this.lastDimensions = { width: null, height: null };
    this.handleChange = this.handleChange.bind(this);
    this.reflowItems = this.reflowItems.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleChange);
    this.mutationObserver = new MutationObserver(this.handleChange);
    this.refs = {};
  }

  static get observedAttributes() {
    return ['disabled', 'minimum-items'];
  }

  get minimumItems() {
    const value = this.getAttribute('minimum-items');
    return value ? parseInt(value, 10) : null;
  }

  get defaultSlot() {
    return this.refs?.defaultSlot;
  }

  get overflowSlot() {
    return this.refs?.overflowSlot;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'disabled') {
      newValue === 'true' ? this.reset() : this.requestReflow();
    }
  }

  connectedCallback() {
    if (!this.shadowRoot) this.initializeShadowRoot();
    this.collectShadowRefs();
    this.addEventListener('reflow', (event) => this.requestReflow(event.detail?.lastVisibleElement));
    this.requestReflow();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    if (this._reflowFrameId !== null) {
      cancelAnimationFrame(this._reflowFrameId);
      this._reflowFrameId = null;
    }
  }

  initializeShadowRoot() {
    const template = this.querySelector(':scope > template');
    if (!(template instanceof HTMLTemplateElement)) return;
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.append(template.content.cloneNode(true));
    template.remove();
  }

  collectShadowRefs() {
    const shadowRoot = this.shadowRoot;
    if (!shadowRoot) throw new Error('Missing shadow root');
    const defaultSlot = shadowRoot.querySelector('slot:not([name])');
    const overflowSlot = shadowRoot.querySelector('slot[name="overflow"]');
    const moreSlot = shadowRoot.querySelector('slot[name="more"]');
    const overflow = shadowRoot.querySelector('[part="overflow"]');
    const list = shadowRoot.querySelector('[part="list"]');
    const placeholder = shadowRoot.querySelector('[part="placeholder"]');
    if (!(defaultSlot instanceof HTMLSlotElement) || !(overflowSlot instanceof HTMLSlotElement) || !(moreSlot instanceof HTMLSlotElement) || !(overflow instanceof HTMLElement) || !(list instanceof HTMLUListElement) || !(placeholder instanceof HTMLLIElement)) {
      throw new Error('Invalid element types in <OverflowList />');
    }
    this.refs = { defaultSlot, overflowSlot, moreSlot, overflow, list, placeholder };
  }

  handleChange(entries) {
    let width = null;
    let height = null;

    for (const entry of entries) {
      if (entry instanceof ResizeObserverEntry) {
        width = Math.round(entry.contentRect.width);
        height = Math.round(entry.contentRect.height);
      }
    }
    // Skip reflow if dimensions are 0 or the same as the last reflow
    const changed = width !== this.lastDimensions.width || height !== this.lastDimensions.height;
    if (changed) {
      this.lastDimensions = { width, height };
      this.requestReflow();
    }
  }

  requestReflow(lastVisibleElement = null) {
    if (this._reflowFrameId !== null) cancelAnimationFrame(this._reflowFrameId);
    this._reflowFrameId = requestAnimationFrame(() => {
      this._reflowFrameId = null;
      this.reflowItems(lastVisibleElement);
    });
  }

  moveItemsToDefaultSlot() {
    const { defaultSlot, overflowSlot } = this.refs;
    for (const element of overflowSlot.assignedElements()) {
      element.slot = defaultSlot.name;
    }
  }

  reset() {
    const { list } = this.refs;
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.moveItemsToDefaultSlot();
    list.style.removeProperty('height');
    this.style.setProperty('--overflow-count', '0');
  }

  updateMinimumReached(visibleElements) {
    if (this.minimumItems !== null) {
      const minimumReached = visibleElements.length < this.minimumItems;
      this.toggleAttribute('minimum-reached', minimumReached);
      this.dispatchEvent(new CustomEvent('overflow-minimum', {
        detail: { minimumReached },
        bubbles: true
      }));
    }
  }

  showAll() {
    const { placeholder } = this.refs;
    placeholder.style.setProperty('width', '0');
    placeholder.style.setProperty('display', 'none');
    this.setAttribute('disabled', 'true');
  }

  reflowItems(lastVisibleElement = null) {
    const { defaultSlot, overflowSlot, moreSlot, list, placeholder } = this.refs;
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    // Avoid layout shifts while reflowing the list
    const { height } = this.firstElementChild?.getBoundingClientRect() ?? {};
    if (height) list.style.height = `${height}px`;
    list.style.setProperty('overflow', 'hidden');
    // Move all elements to the default slot so we can check which ones overflow
    this.moveItemsToDefaultSlot();
    const elements = defaultSlot.assignedElements();
    moreSlot.hidden = true;
    placeholder.hidden = true;
    const listRect = list.getBoundingClientRect();
    // Store the initial dimensions for comparison later
    this.lastDimensions = { width: Math.round(listRect.width), height: Math.round(listRect.height) };
    const getVisibleElements = () => {
      return elements.filter(element => {
        const rect = element.getBoundingClientRect();
        return rect.top <= listRect.top + 1
      });
    };
    let visibleElements = getVisibleElements();
    // If not all items fit or we have a lastVisibleElement, let's calculate with "More" button
    if (visibleElements.length < elements.length || lastVisibleElement) {
      // Putting the "More" item (and lastVisibleElement, if provided) at the start of the list lets us see which items will fit on the same row
      moreSlot.style.setProperty('order', '-1');
      moreSlot.hidden = false;
      moreSlot.style.setProperty('height', `${height}px`);
      if (lastVisibleElement) lastVisibleElement.style.setProperty('order', '-1');
      // Recalculate the visible elements
      visibleElements = getVisibleElements();
      // Reset the order
      moreSlot.style.removeProperty('order');
      if (lastVisibleElement) lastVisibleElement.style.removeProperty('order');
      // If we have a lastVisibleElement, ensure it's in the last visible position
      if (lastVisibleElement && visibleElements.includes(lastVisibleElement)) {
        visibleElements = visibleElements.filter(element => element !== lastVisibleElement);
        visibleElements.push(lastVisibleElement);
      }
      moreSlot.style.setProperty('height', 'auto');
    }

    const overflowingElements = elements.filter(element => !visibleElements.includes(element));
    const [firstOverflowingElement] = overflowingElements;
    const hasOverflow = overflowingElements.length > 0;
    const placeholderWidth = firstOverflowingElement ? firstOverflowingElement.clientWidth : 0;
    // Move the elements to the correct slot
    for (const element of elements) {
      element.slot = overflowingElements.includes(element) ? overflowSlot.name : defaultSlot.name;
    }
    // If there are overflowing elements
    // Show more button and placeholder if needed
    moreSlot.hidden = !hasOverflow;
    if (hasOverflow) {
      // Set the width and height of the placeholder so the list can grow if there is space
      placeholder.style.width = `${placeholderWidth}px`;
      placeholder.hidden = false;
    }

    list.style.setProperty('counter-reset', `overflow-count ${overflowingElements.length}`);
    this.style.setProperty('--overflow-count', `${overflowingElements.length}`);
    list.style.removeProperty('overflow');
    // Check if the minimum-reached state should be updated
    hasOverflow && this.updateMinimumReached(visibleElements);
    // Observe the list for changes in size
    this.resizeObserver.observe(this);
    this.mutationObserver.observe(this, { childList: true });
  }
}

customElements.define('overflow-list', OverflowList);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class QuickAddModal extends ModalDialog {
  constructor() {
    super();
    this.moved = true;
    this.loadingOverlay = this.querySelector('[id^="LoadingOverlay"]');
    this.modalContent = this.querySelector('[id^="QuickAddInfoModal"]');
  }

  show(opener) {
    opener.setAttribute('aria-disabled', true);
    const parentDialog = opener.closest('.modal') || opener.closest('cart-notification');
    if (parentDialog) parentDialog.hide();
    super.show(opener);
    this.enableLoading();
    fetch(opener.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
        injectHTMLWithScripts(this.modalContent, this.productElement.innerHTML);
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        this.disableLoading();
        this.classList.add('has-content');
      })
      .finally(() => {
        opener.removeAttribute('aria-disabled');
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
      });
  }

  hide(preventFocus = false) {
    if (preventFocus) this.activeElement = null;
    super.hide();
    injectHTMLWithScripts(this.modalContent, '');
    this.classList.remove('has-content');
  }

  enableLoading() {
    this.loadingOverlay.enableLoading();
  }

  disableLoading() {
    this.loadingOverlay.disableLoading();
  }
}

customElements.define('quick-add-modal', QuickAddModal);

class QuickViewModal extends ModalDialog {
  constructor() {
    super();
    this.moved = true;
    this.loadingOverlay = this.querySelector('[id^="LoadingOverlay"]');
    this.modalContent = this.querySelector('[id^="QuickViewInfoModal"]');
  }

  show(opener) {
    opener.setAttribute('aria-disabled', true);
    const parentDialog = opener.closest('.modal') || opener.closest('cart-notification');
    if (parentDialog) parentDialog.hide();
    super.show(opener);
    this.enableLoading();
    fetch(opener.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
        injectHTMLWithScripts(this.modalContent, this.productElement.innerHTML);
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        this.disableLoading();
        this.classList.add('has-content');
      })
      .finally(() => {
        opener.removeAttribute('aria-disabled');
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
      });
  }

  hide(preventFocus = false) {
    if (preventFocus) this.activeElement = null;
    super.hide();
    injectHTMLWithScripts(this.modalContent, '');
    this.classList.remove('has-content');
  }

  enableLoading() {
    this.loadingOverlay.enableLoading();
  }

  disableLoading() {
    this.loadingOverlay.disableLoading();
  }
}

customElements.define('quick-view-modal', QuickViewModal);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 400
    });
  }

  init() {
    this.list = readCookie('shopify_recently_viewed_products');
    if (this.list.length === 0) {
      this.checkContent();
      return
    }
    this.loadContent();
  }

  getQueryString(list) {
    if (this.dataset.productId && list.includes(parseInt(this.dataset.productId))) list.splice(list.indexOf(parseInt(this.dataset.productId)), 1);
    return list.map((item) => "id:" + item).slice(0, 10).join(" OR ");
  }

  checkContent(html = null) {
    this.setAttribute('loaded', true);
    this.products = html ? Array.from(html.querySelectorAll('[data-product-item]')) : [];
    if (this.products.length === 0) {
      this.remove();
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      fetch(this.dataset.url + this.getQueryString(this.list))
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const products = html.querySelector('recently-viewed-products');
          if (products && products.innerHTML.trim().length) this.innerHTML = products.innerHTML;
          this.checkContent(html);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);

class ScrollShadow extends HTMLElement {
  static updaters = new WeakMap();

  static Updater = class {
    constructor(targetElement) {
      const update = this.update.bind(this, targetElement, getComputedStyle(targetElement));
      this.handleScroll = this.throttle(update);
      this.resizeObserver = new ResizeObserver(update);
    }

    clamp(num, min = 0, max) {
      if (num < min) return min;
      if (num > max) return max;
      return num;
    }

    throttle(callback) {
      let id = null;
      return () => {
        if (id) return;
        id = requestAnimationFrame(() => {
          callback();
          id = null;
        });
      };
    }

    start(element, rootElement) {
      if (this.element) this.stop();
      if (element) {
        element.addEventListener('scroll', this.handleScroll);
        this.resizeObserver.observe(element);
        this.element = element;
      }
      if (rootElement) {
        this.resizeObserver.observe(rootElement);
        this.rootElement = rootElement;
      }
    }

    stop() {
      if (!this.element) return;
      this.element.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver.disconnect();
      this.element = null;
      this.rootElement = null;
    }

    update(targetElement, computedStyle) {
      const { element, rootElement } = this;
      if (!element) return;
      const maxSize = Number(computedStyle.getPropertyValue('--scroll-shadow-size') || 14);
      const style = {
        '--top': this.clamp(element.scrollTop, 0, maxSize),
        '--bottom': this.clamp(element.scrollHeight - element.offsetHeight - element.scrollTop, 0, maxSize),
        '--left': this.clamp(element.scrollLeft, 0, maxSize),
        '--right': this.clamp(element.scrollWidth - element.offsetWidth - element.scrollLeft, 0, maxSize),
      };

      if (rootElement) {
        const clientRect = element.getBoundingClientRect();
        const rootClientRect = rootElement.getBoundingClientRect();
        Object.assign(style, {
          top: this.clamp(clientRect.top - rootClientRect.top),
          bottom: this.clamp(rootClientRect.bottom - clientRect.bottom),
          left: this.clamp(clientRect.left - rootClientRect.left),
          right: this.clamp(rootClientRect.right - clientRect.right),
        });
      }

      for (const key in style) {
        targetElement.style.setProperty(key, `${style[key]}px`);
      }
    }
  };

  constructor() {
    super();
    this.template = `
      <style>
      :host {
        display: inline-block;
        position: relative;
      }
      :host([hidden]) {
        display: none;
      }
      s {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
        z-index: var(--z-index-temporary, 5);
        background:
          var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(var(--color-foreground),.2), rgba(var(--color-foreground),0))) top/100% var(--top),
          var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(var(--color-foreground),.2), rgba(var(--color-foreground),0))) bottom/100% var(--bottom),
          var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(var(--color-foreground),.2), rgba(var(--color-foreground),0))) left/var(--left) 100%,
          var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(var(--color-foreground),.2), rgba(var(--color-foreground),0))) right/var(--right) 100%;
        background-repeat: no-repeat;
      }
      </style>
      <slot></slot>
      <s></s>
    `;
    this.attachShadow({ mode: 'open' }).innerHTML = this.template;
    ScrollShadow.updaters.set(this, new ScrollShadow.Updater(this.shadowRoot.lastElementChild));
  }

  static get observedAttributes() {
    return ['element'];
  }

  get element() {
    return this.getAttribute('element');
  }

  set element(value) {
    this.setAttribute('element', value);
  }

  connectedCallback() {
    this.shadowRoot.querySelector('slot').addEventListener('slotchange', () => this.start());
    this.start();
  }

  disconnectedCallback() {
    ScrollShadow.updaters.get(this).stop();
  }

  start() {
    const element = this.scrollElement || this.firstElementChild;
    ScrollShadow.updaters.get(this).start(element, this.scrollElement ? this.firstElementChild : null);
  }

  attributeChangedCallback(_name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.scrollElement = newValue ? this.querySelector(newValue) : null;
      this.start();
    }
  }
}

customElements.define('scroll-shadow', ScrollShadow);

class ScrollTopButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const buttons = this.querySelectorAll('button');
    [...buttons].forEach((button) => button.addEventListener('click', this.handleScrollTop.bind(this)));
  }

  disconnectedCallback() {
    // code here
  }

  handleScrollTop(event) {
    event.preventDefault();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }
}

customElements.define('scroll-top-button', ScrollTopButton);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.onFormReset = this.onFormReset.bind(this);
    this.onChange = this.onChange.bind(this);
    this.inputHandler = debounce(this.onChange, ON_CHANGE_DEBOUNCE_TIMER);
  }

  connectedCallback() {
    this.inputSearch = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (!this.inputSearch) return;
    this.form = this.inputSearch.form;
    if (this.form) this.form.addEventListener('reset', this.onFormReset);
    this.inputSearch.addEventListener('input', this.inputHandler);
    this.toggleResetButton();
  }

  disconnectedCallback() {
    if (this.inputSearch) this.inputSearch.removeEventListener('input', this.inputHandler);
    if (this.form) this.form.removeEventListener('reset', this.onFormReset);
  }

  toggleResetButton() {
    if (!this.resetButton || !this.inputSearch) return;
    const hasValue = this.inputSearch.value.length > 0;
    this.resetButton.classList.toggle('hidden', !hasValue);
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    event.preventDefault();
    if (!this.inputSearch) return;

    if (this.shouldResetForm()) {
      this.inputSearch.value = '';
      this.inputSearch.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class SecondaryImages extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  get template() {
    return this._template = this._template || this.querySelector(':scope > template')
  }

  get container() {
    return this._container = this._container || this.querySelector('[data-swiper-container]') || this.querySelector('.swiper')
  }

  get wrapper() {
    return this._wrapper = this._wrapper || this.querySelector('[data-swiper-wrapper]') || this.querySelector('.swiper-wrapper')
  }

  get pagination() {
    return document.querySelector(`#Pagination-Slider-${this.dataset.sliderId}`) || this.querySelector('.swiper-pagination')
  }

  get prev() {
    return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-prev`) || this.querySelector('.swiper-button-prev')
  }

  get next() {
    return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-next`) || this.querySelector('.swiper-button-next')
  }

  get max() {
    return this._max = this._max || Number(this.dataset.maxImages)
  }

  getActiveSlideDetail() {
    const activeIndex = this.swiper?.activeIndex;
    const activeSlide = Number.isInteger(activeIndex) ? this.swiper?.slides?.[activeIndex] || null : null;
    const dataIndex = activeSlide?.dataset?.index;

    return {
      id: this.dataset.sliderId,
      currentPage: activeIndex,
      activeIndex,
      activeSlide,
      activeDataIndex: typeof dataIndex === 'undefined' ? null : Number(dataIndex)
    };
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: this.threshold
    });
  }

  disconnectedCallback() {
    // code here
  }

  init() {
    if (this.hasAttribute('loaded')) return;
    this.template.replaceWith(this.template.content.firstElementChild.cloneNode(true));
    this.options = this.swiperOptions();
    if (!this.swiper) this.swiperInitilize();
    this.setAttribute('loaded', true);
    this.dispatchEvent(new CustomEvent('secondary-images:loaded', { bubbles: true }));
  }

  bindEvents() {
    if (!this.swiper) return;

    this._onSlideChange = () => {
      this.swiper.pagination.render();
      this.swiper.pagination.update();
      this.swiper.navigation.destroy();
      this.swiper.navigation.init();
      this.dispatchEvent(new CustomEvent('slider:change', {
        bubbles: true,
        detail: this.getActiveSlideDetail()
      }));
    };

    this._onTransitionStart = () => {
      this.swiper.mousewheel.enabled = false;
    };

    this._onTransitionEnd = () => {
      this.swiper.mousewheel.enabled = true;
    };

    this.swiper.on('slideChange', this._onSlideChange);
    this.swiper.on('transitionStart', this._onTransitionStart);
    this.swiper.on('transitionEnd', this._onTransitionEnd);
  }

  unBindEvents() {
    if (!this.swiper) return;

    this.swiper.off('slideChange', this._onSlideChange);
    this.swiper.off('transitionStart', this._onTransitionStart);
    this.swiper.off('transitionEnd', this._onTransitionEnd);

    this._onSlideChange = null;
    this._onTransitionStart = null;
    this._onTransitionEnd = null;
  }

  swiperOptions() {
    let defaultOptions = {};
    try {
      defaultOptions = JSON.parse(this.dataset.swiper || '{}');
    } catch (e) {
      console.error('Invalid JSON in data-swiper:', e);
    }
    let navigation = {
      prevEl: this.prev,
      nextEl: this.next
    };
    let pagination = {
      el: this.pagination,
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class="${className}">${index + 1}</span>`;
      }
    };
    let options = { ...defaultOptions };
    options = {
      ...options,
      pagination: {
        ...pagination
      },
      navigation: {
        ...navigation
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          this.checkNavigation(element);
          this.checkPagination(element);
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        },
        resize: (element) => {
          this.checkNavigation(element);
          this.checkPagination(element);
        },
        update: (element) => {
          this.checkNavigation(element);
          this.checkPagination(element);
        }
      }
    }

    return options
  }

  swiperInitilize() {
    if (!this.container.classList.contains('swiper')) this.container.classList.add('swiper');
    if (!this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.add('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (!element.classList.contains('swiper-slide')) element.classList.add('swiper-slide')
    });
    this.swiper = new Swiper(this.container, this.options);
    this.dispatchEvent(new CustomEvent('slider:init', {
      bubbles: true,
      detail: {
        id: this.dataset.sliderId,
        swiper: this.swiper
      }
    }));
    this.bindEvents();
  }

  swiperDestroy() {
    this.unBindEvents();
    this.swiper?.destroy(true, true);
    this.swiper = null;
    if (this.container.classList.contains('swiper')) this.container.classList.remove('swiper');
    if (this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.remove('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (element.classList.contains('swiper-slide')) element.classList.remove('swiper-slide')
    });
    this.dispatchEvent(new CustomEvent('slider:destroy', {
      bubbles: true,
      detail: {
        id: this.dataset.sliderId
      }
    }));
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    this.classList.add('has-pagination');
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    this.classList.add('has-navigation');
  }
}

customElements.define('secondary-images', SecondaryImages);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', this.expandShowMore.bind(this));
  }

  expandShowMore(event) {
    const button = event.currentTarget;
    const parent = button.closest('.parent-wrap');
    button.classList.toggle('show');
    button.querySelector('span').innerText = button.classList.contains('show') ? button.dataset.showLessText : button.dataset.showMoreText;
    parent.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);

class SideDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  get overlay() {
    return this.querySelector('[id^="Drawer-Overlay-"]');
  }

  connectedCallback() {
    this.bindEvents();
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
  }

  lockScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    document.documentElement.dataset.scrollY = scrollY;
    document.documentElement.style.scrollBehavior = 'auto';
    document.documentElement.classList.add('is-locked');
    document.documentElement.style.top = `-${scrollY}px`;
  }

  unlockScroll() {
    const scrollY = parseInt(document.documentElement.dataset.scrollY || '0', 10);
    document.documentElement.classList.remove('is-locked');
    document.documentElement.style.top = '';
    window.scrollTo(0, scrollY);
    document.documentElement.style.scrollBehavior = '';
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.close.bind(this));
  }

  loadContent() {
    const templateDrawer = this.querySelector('.template-drawer');
    if (!templateDrawer) return;
    if (!this.getAttribute('loaded')) {
      templateDrawer.replaceWith(templateDrawer.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (this.activeElement) this.activeElement.setAttribute('open', '');
    this.loadContent();
    setTimeout(() => this.classList.add('animate', 'active'));
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.drawer__details') || this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('drawer-show');
    this.lockScroll();
  }

  close() {
    this.classList.remove('animate', 'active');
    if (this.activeElement) this.activeElement.removeAttribute('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('drawer-show');
    this.unlockScroll();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('side-drawer', SideDrawer);

class SideDrawerOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    let _target = event.currentTarget;
    const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
    drawer && (_target.hasAttribute('open') ? drawer.close() : drawer.open(_target));
  }
}

customElements.define('side-drawer-opener', SideDrawerOpener);

class StickyElement extends HTMLElement {
  constructor() {
    super();
  }

  get section() {
    return this._section || (this._section = this.closest('.shopify-section'))
  }

  get type() {
    return this._type = this._type || this.dataset.type
  }

  get anchor() {
    return this._anchor || (this._anchor = this.section?.querySelector(this.dataset.anchor))
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    this.classList.remove('hidden');
    if (this.anchor && this.isPastThreshold(this.anchor, 100)) {
      requestAnimationFrame(() => this.show());
    } else {
      requestAnimationFrame(() => this.hide());
    }
  }

  isPastThreshold(element, threshold = 0) {
    return element.getBoundingClientRect().y + threshold < 0
  }

  hide() {
    this.classList.remove('animate', 'active');
    document.body.classList.remove(`${this.type}-sticky__show`);
    document.body.style.setProperty(`--${this.type}-sticky-height`, '0px');
  }

  show() {
    this.classList.add('animate', 'active');
    document.body.classList.add(`${this.type}-sticky__show`);
    document.body.style.setProperty(`--${this.type}-sticky-height`, `${Math.floor(this.offsetHeight)}px`);
  }
}

customElements.define('sticky-element', StickyElement);

class ThemeSwiper extends HTMLElement {
  constructor() {
    super();
    this._onVideoEnded = null;
    this.lastOutIndex = null;
    this.swiper = null;
    this._controllerSwiper = null;
    this._controllerInitListener = null;
    this._syncFromControllerSlideChange = null;
    this._syncFromControllerClick = null;
    this.breakpointList = ['small', 'medium', 'large-up'];
    this.boundPlaySlider = this.playSlider.bind(this);
    this.boundPauseSlider = this.pauseSlider.bind(this);
  }

  get threshold() {
    return Number(this.getAttribute('data-threshold') ?? -200)
  }

  get container() {
    return this._container = this._container || this.querySelector('[data-swiper-container]') || this.querySelector('.swiper')
  }

  get wrapper() {
    return this._wrapper = this._wrapper || this.querySelector('[data-swiper-wrapper]') || this.querySelector('.swiper-wrapper')
  }

  get scrollbar() {
    return document.querySelector(`#Scrollbar-Slider-${this.dataset.sliderId}`) || this.querySelector(':scope > .swiper-scrollbar')
  }

  get pagination() {
    return document.querySelector(`#Pagination-Slider-${this.dataset.sliderId}`) || this.querySelector(':scope > .swiper-pagination')
  }

  get prev() {
    return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-prev`) || this.querySelector(':scope > .swiper-button-prev')
  }

  get next() {
    return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-next`) || this.querySelector(':scope > .swiper-button-next')
  }

  get playButton() {
    return this.querySelector('.swiper-button-play')
  }

  get pauseButton() {
    return this.querySelector('.swiper-button-pause')
  }

  get resolution() {
    return this.getAttribute('data-resolution')
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  get items() {
    if (!this._items) {
      let items = Array.from(this.querySelectorAll('[data-swiper-slide]'));
      if (items.length === 0) {
        items = Array.from(this.querySelectorAll('.swiper-slide'));
      }
      this._items = items;
    }
    return this._items
  }

  get markedItem() {
    return this._markedItem = this._markedItem || this.querySelector('.swiper-slide.swiper-slide-active [data-marked]');
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: this.threshold
      });
    } else {
      this.init();
    }
    this.playButton?.addEventListener('click', this.boundPlaySlider);
    this.pauseButton?.addEventListener('click', this.boundPauseSlider);

    if (this.resolution) {
      const mq = window.matchMedia(this.resolution);
      this._resolutionListener = () => this.init();
      mq.addEventListener('change', this._resolutionListener);
    }
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.boundPlaySlider);
    this.pauseButton?.removeEventListener('click', this.boundPauseSlider);

    if (this.resolution && this._resolutionListener) {
      const mq = window.matchMedia(this.resolution);
      mq.removeEventListener('change', this._resolutionListener);
      this._resolutionListener = null;
    }
  }

  init() {
    this.options = this.swiperOptions();
    if (this.resolution != undefined) {
      if (window.matchMedia(this.resolution).matches) {
        if (!this.swiper) this.swiperInitilize();
      } else {
        if (this.swiper) this.swiperDestroy();
      }
    } else {
      if (!this.swiper) this.swiperInitilize();
    }
  }

  bindEvents() {
    if (!this.swiper) return;

    this._onSlideChange = () => {
      this.swiper.pagination.render();
      this.swiper.pagination.update();
      this.swiper.navigation.destroy();
      this.swiper.navigation.init();
      this.dispatchEvent(new CustomEvent('slider:change', {
        bubbles: true,
        detail: { currentPage: this.swiper.activeIndex }
      }));
    };

    this._onTransitionStart = () => {
      const oldIndex = this.swiper.previousIndex !== this.swiper.activeIndex
        ? this.swiper.previousIndex
        : this.lastOutIndex;
      const oldSlide = this.swiper.slides[oldIndex];
      if (oldSlide?.dataset.type === 'video') this.handleVideoOut(oldSlide, this.swiper);
      this.swiper.mousewheel.enabled = false;
      this.lastOutIndex = this.swiper.previousIndex;
    };

    this._onTransitionEnd = () => {
      const newSlide = this.swiper.slides[this.swiper.activeIndex];
      if (newSlide?.dataset.type === 'video') this.handleVideoIn(newSlide, this.swiper);
      this.swiper.mousewheel.enabled = true;
      this.lastOutIndex = this.swiper.activeIndex;
      this.setSlideEdges(this.swiper);
    };

    this._onPaginationUpdate = () => this.updatePagination(this.swiper);
    this._onSlideChangeTransitionEnd = () => this.handleLoop(this.swiper);
    this._onAutoplayPause = () => this.setAutoplayState(this.swiper);
    this._onAutoplayResume = () => this.setAutoplayState(this.swiper);
    this._onAutoplayStop = () => this.setAutoplayState(this.swiper);
    this._onAutoplayStart = () => this.setAutoplayState(this.swiper);
    this.swiper.on('slideChange', this._onSlideChange);
    this.swiper.on('transitionStart', this._onTransitionStart);
    this.swiper.on('transitionEnd', this._onTransitionEnd);
    this.swiper.on('paginationUpdate', this._onPaginationUpdate);
    this.swiper.on('slideChangeTransitionEnd', this._onSlideChangeTransitionEnd);
    this.swiper.on('autoplayPause', this._onAutoplayPause);
    this.swiper.on('autoplayResume', this._onAutoplayResume);
    this.swiper.on('autoplayStart', this._onAutoplayStart);
    this.swiper.on('autoplayStop', this._onAutoplayStop);
    this.setupControllerSync();

    if (Shopify.designMode) {
      const section = this.closest('.shopify-section');
      this._onBlockSelect = this.onBlockSelect.bind(this);
      this._onSectionSelect = this.onSectionSelect.bind(this);
      section.addEventListener('shopify:section:load', this._onSectionSelect);
      section.addEventListener('shopify:section:unload', this._onSectionSelect);
      section.addEventListener('shopify:section:reorder', this._onSectionSelect);
      this.addEventListener('shopify:block:select', this._onBlockSelect);
    }
  }

  unBindEvents() {
    if (!this.swiper) return;

    this.swiper.off('slideChange', this._onSlideChange);
    this.swiper.off('transitionStart', this._onTransitionStart);
    this.swiper.off('transitionEnd', this._onTransitionEnd);
    this.swiper.off('paginationUpdate', this._onPaginationUpdate);
    this.swiper.off('slideChangeTransitionEnd', this._onSlideChangeTransitionEnd);
    this.swiper.off('autoplayPause', this._onAutoplayPause);
    this.swiper.off('autoplayResume', this._onAutoplayResume);
    this.swiper.off('autoplayStart', this._onAutoplayStart);
    this.swiper.off('autoplayStop', this._onAutoplayStop);
    this.teardownControllerSync();

    this._onSlideChange = null;
    this._onTransitionStart = null;
    this._onTransitionEnd = null;
    this._onPaginationUpdate = null;
    this._onSlideChangeTransitionEnd = null;
    this._onAutoplayPause = null;
    this._onAutoplayResume = null;
    this._onAutoplayStop = null;
    this._onAutoplayStart = null;
    this.lastOutIndex = null;

    if (Shopify.designMode) {
      if (this._onBlockSelect) {
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
        this._onBlockSelect = null;
      }

      if (this._onSectionSelect) {
        const section = this.closest('.shopify-section');
        section.removeEventListener('shopify:section:load', this._onSectionSelect);
        section.removeEventListener('shopify:section:unload', this._onSectionSelect);
        section.removeEventListener('shopify:section:reorder', this._onSectionSelect);
        this._onSectionSelect = null;
      }
    }
  }

  swiperOptions() {
    let defaultOptions = {};
    try {
      defaultOptions = JSON.parse(this.dataset.swiper || '{}');
    } catch (e) {
      console.error('Invalid JSON in data-swiper:', e);
    }
    let navigation = {
      prevEl: this.prev,
      nextEl: this.next
    };
    let pagination = {};
    if (this.pagination != undefined) {
      let isFraction = this.pagination.classList.contains('fraction');
      if (isFraction) {
        pagination = {
          el: this.pagination,
          type: 'fraction',
          renderFraction: (currentClass, totalClass) => `
            <span class="${currentClass}"></span>
            <span class="swiper-pagination-separator"> / </span>
            <span class="${totalClass}"></span>
          `
        };
      } else {
        pagination = {
          el: this.pagination,
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}">${index + 1}</span>`;
          }
        };
      }
    }
    let options = { ...defaultOptions };
    options = {
      ...options,
      pagination: {
        ...pagination
      },
      navigation: {
        ...navigation
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          const selectedElement = element.slides[element.activeIndex];
          if (selectedElement && selectedElement.dataset.type === 'video') this.handleVideoIn(selectedElement, element);
          const indexInit = this.indexInit || this.dataset.activeIndexInit;
          indexInit && this.setActiveSlideItem(indexInit);
          this.setSlideHeight();
          this.setSlideEdges(element);
          this.checkNavigation(element);
          this.checkPagination(element);
          this.updatePagination(element);
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
          this.dispatchEvent(new CustomEvent('slider:change', {
            bubbles: true,
            detail: { currentPage: element.activeIndex }
          }));
        },
        resize: (element) => {
          this.setSlideHeight();
          this.setSlideEdges(element);
          this.checkNavigation(element);
          this.checkPagination(element);
        },
        update: (element) => {
          this.setSlideHeight();
          this.setSlideEdges(element);
          this.checkNavigation(element);
          this.checkPagination(element);
        }
      }
    }

    return options
  }

  swiperInitilize() {
    if (!this.container.classList.contains('swiper')) this.container.classList.add('swiper');
    if (!this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.add('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (!element.classList.contains('swiper-slide')) element.classList.add('swiper-slide')
    });
    this.swiper = new Swiper(this.container, this.options);
    this.dispatchEvent(new CustomEvent('slider:init', {
      bubbles: true,
      detail: {
        id: this.dataset.sliderId,
        swiper: this.swiper
      }
    }));
    this.bindEvents();
  }

  swiperDestroy() {
    this.unBindEvents();
    this.swiper?.destroy(true, true);
    this.swiper = null;
    if (this.container.classList.contains('swiper')) this.container.classList.remove('swiper');
    if (this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.remove('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (element.classList.contains('swiper-slide')) element.classList.remove('swiper-slide')
    });
    this.dispatchEvent(new CustomEvent('slider:destroy', {
      bubbles: true,
      detail: {
        id: this.dataset.sliderId
      }
    }));
  }

  setActiveSlideItem(activeIndex) {
    if (typeof activeIndex === 'undefined' || activeIndex === null) return;
    const idx = Number(activeIndex);
    if (Number.isFinite(idx)) {
      this.swiper?.params?.loop ? this.swiper.slideToLoop(idx) : this.swiper?.slideTo(idx);
    }
  }

  setSlideHeight() {
    if (!this.markedItem) return;
    this.style.setProperty('--slide-height', `${this.markedItem.offsetHeight}px`);
  }

  setSlideEdges(swiper) {
    const isBeginning = swiper.isBeginning;
    const isEnd = swiper.isEnd;
    swiper.el.classList.toggle('show-left', !isBeginning);
    swiper.el.classList.toggle('show-right', !isEnd);
  }

  setAutoplayState(swiper) {
    if (!swiper?.autoplay) return;
    const isStopped = swiper.autoplay.running === false;
    const isPaused = swiper.autoplay.paused === true && !isStopped;
    this.classList.toggle('theme-swiper--stopped', isStopped);
    this.classList.toggle('theme-swiper--paused', isPaused);
  }

  handleLoop(swiper) {
    if (this.hasAttribute('data-skip-loop-fix')) return;
    if (swiper && swiper.params.loop) swiper.loopFix();
  }

  handleVideoOut(oldElement, swiper) {
    if (!oldElement) return;
    const videoElement = window.visibleMedia(oldElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    videoElement.pause();
    videoElement.updateControlButton(true);
    videoElement.updateSoundButton(true);
    if (this._onVideoEnded) {
      videoElement.removeEventListener('video:ended', this._onVideoEnded);
      this._onVideoEnded = null;
    }
  }

  handleVideoIn(newElement, swiper) {
    if (!newElement) return;
    const videoElement = window.visibleMedia(newElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    const autoplayEnabled = Boolean(swiper?.params?.autoplay?.enabled);
    const autoplayWasRunning = autoplayEnabled && swiper.autoplay.running;
    if (autoplayWasRunning) {
      // swiper.params.autoplay.delay = 0;
      swiper.autoplay.stop();
    }
    videoElement.play();
    videoElement.updateControlButton(false);
    videoElement.updateSoundButton(false);
    const handleVideoEnd = () => {
      this._onVideoEnded = null;
      videoElement.removeEventListener('video:ended', handleVideoEnd);
      if (autoplayWasRunning) {
        if (!swiper.autoplay.running) swiper.autoplay.start();
        swiper.slideNext();
        //  swiper.params.autoplay.delay = this.autoplayDelayTime;
      }
    };
    this._onVideoEnded = handleVideoEnd;
    videoElement.addEventListener('video:ended', this._onVideoEnded);
  }

  handleTabindex(swiper) {
    const focusableSelectors = 'a, button, input, textarea, select, [tabindex]';
    const totalSlides = swiper.slides.length;
    const slidesPerView = swiper.params.slidesPerView;
    if (swiper && totalSlides > slidesPerView) {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', '-1'));
      });
      swiper.slides[swiper.activeIndex]?.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', element.hasAttribute('data-omit-tabindex') ? '-1' : '0'));
    } else {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', element.hasAttribute('data-omit-tabindex') ? '-1' : '0'));
      });
    }
  }

  handleKeyboard(event) {
    const keyCode = event.keyCode || event.which;
    const focusedElement = document.activeElement;
    if (this.swiper && this.swiper.el.contains(focusedElement)) {
      switch (keyCode) {
        case 37:
          this.swiper.slidePrev();
          break;
        case 39:
          this.swiper.slideNext();
          break;
      }
    }
  }

  playSlider(event) {
    this.togglePlayPause(event.currentTarget.name);
    if (this.swiper) {
      this.swiper.params.autoplay.delay = this.autoplayDelayTime;
      this.swiper.autoplay.start();
    }
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider(event) {
    this.togglePlayPause(event.currentTarget.name);
    if (this.swiper) {
      this.swiper.params.autoplay.delay = 0;
      this.swiper.autoplay.stop();
    }
    this.classList.add('theme-swiper--paused');
  }

  togglePlayPause(state = 'play') {
    if (state == 'play') {
      this.playButton?.classList.add('hidden');
      this.pauseButton?.classList.remove('hidden');
    } else if (state == 'pause') {
      this.pauseButton?.classList.add('hidden');
      this.playButton?.classList.remove('hidden');
    }
  }

  updatePagination(swiper) {
    if (!swiper) return;
    if (swiper.params?.pagination?.type !== 'bullets') return;
    const cloneSlides = swiper.el.querySelectorAll('.swiper-slide-duplicate, .swiper-slide--cloned');
    if (cloneSlides.length === 0) return;
    const bullets = swiper.pagination.bullets;
    if (bullets.length <= 1) return;
    const index = swiper.realIndex - 1;
    const halfLength = Math.floor(bullets.length / 2);
    if (index >= halfLength - 1) {
      for (let i = 0; i < halfLength; i++) {
        bullets[i].style.display = 'none';
      }
    } else {
      for (let i = halfLength; i < bullets.length; i++) {
        bullets[i].style.display = 'none';
      }
    }
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-pagination', !pagination.el.classList.contains(`${breakpoint}-hide`));
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-navigation', !navigation.nextEl.closest('.swiper-navigation').classList.contains(`${breakpoint}-hide`));
  }

  onSectionSelect(event) {
    const activeItem = event.target.querySelector('.swiper-slide-active');
    if (!activeItem) return;
    // if(!this.indexInit) this.indexInit = Number(activeItem.dataset.index);
    this.setActiveSlideItem(activeItem.dataset.index)
  }

  onBlockSelect(event) {
    // if(!this.indexInit) this.indexInit =  Number(event.target.dataset.index);
    this.setActiveSlideItem(event.target.dataset.index)
  }

  resolvePeerSwiper(selector) {
    if (!selector) return null;
    try {
      const element = document.querySelector(selector);
      return element?.swiper ?? null;
    } catch (error) {
      return null;
    }
  }

  setupControllerSync() {
    this.teardownControllerSync();
    if (!this.swiper) return;
    const controllerSelector = this.dataset.controlledBy;
    if (!controllerSelector) return;

    const attach = (controllerSwiper) => {
      if (!controllerSwiper) return;
      const controllerEl = controllerSwiper.el;
      const thisId = this.id || this.dataset.sliderId;
      const configuredThumbs = this.swiper?.thumbs?.swiper || this.swiper?.params?.thumbs?.swiper;
      if (configuredThumbs) {
        const isConfiguredInstance = configuredThumbs === controllerSwiper;
        const isConfiguredElement = configuredThumbs === controllerEl;
        const isConfiguredSelector = typeof configuredThumbs === 'string' ? document.querySelector(configuredThumbs)?.swiper === controllerSwiper : false;
        if (!isConfiguredInstance && !isConfiguredElement && !isConfiguredSelector) return;
      } else {
        const thumbsTarget = controllerEl?.closest('theme-swiper')?.dataset?.thumbsFor;
        if (!thumbsTarget || (thumbsTarget !== thisId && thumbsTarget !== `#${thisId}`)) return;
      }

      this._controllerSwiper = controllerSwiper;
      // Avoid "last visible thumb click jumps to next group" behavior.
      if (this._controllerSwiper?.params?.slideToClickedSlide) {
        this._controllerSwiper.params.slideToClickedSlide = false;
      }

      const getIndexFromSlideEl = (slideEl) => {
        if (!slideEl) return NaN;
        const v = slideEl.dataset?.index;
        const n = Number(v);
        return Number.isFinite(n) ? n : NaN;
      };

      const slideMainTo = (index) => {
        if (!Number.isFinite(index)) return;
        if (this.swiper?.params?.loop) this.swiper.slideToLoop(index);
        else this.swiper.slideTo(index);
      };

      this._syncFromControllerClick = (swiper) => {
        const clickedIndex = getIndexFromSlideEl(swiper.clickedSlide);
        if (Number.isFinite(clickedIndex)) {
          slideMainTo(clickedIndex);
          swiper.updateSlidesClasses();
          return;
        }
      };

      this._syncFromControllerSlideChange = () => {
        const idx = Number.isFinite(controllerSwiper.realIndex) ? controllerSwiper.realIndex : controllerSwiper.activeIndex;
        slideMainTo(idx);
      };

      controllerSwiper.on('click', this._syncFromControllerClick);
      controllerSwiper.on('slideChange', this._syncFromControllerSlideChange);

      this._syncFromControllerSlideChange();
    };

    const controllerSwiper = this.resolvePeerSwiper(controllerSelector);

    if (controllerSwiper) {
      attach(controllerSwiper);
    } else {
      this._controllerInitListener = (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (!target.matches(controllerSelector)) return;

        attach(target.swiper);

        if (this._controllerInitListener) {
          document.removeEventListener('slider:init', this._controllerInitListener);
          this._controllerInitListener = null;
        }
      };
      document.addEventListener('slider:init', this._controllerInitListener);
    }
  }

  teardownControllerSync() {
    if (this._controllerSwiper) {
      if (this._syncFromControllerSlideChange) this._controllerSwiper.off('slideChange', this._syncFromControllerSlideChange);
      if (this._syncFromControllerClick) this._controllerSwiper.off('click', this._syncFromControllerClick);
    }
    if (this._controllerInitListener) {
      document.removeEventListener('slider:init', this._controllerInitListener);
    }
    this._controllerSwiper = null;
    this._syncFromControllerSlideChange = null;
    this._syncFromControllerClick = null;
    this._controllerInitListener = null;
  }
}

customElements.define('theme-swiper', ThemeSwiper);

class ThemeSwiperControls extends HTMLElement {
  constructor() {
    super();
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.paginationEl = this.querySelector('.theme-swiper-controls__pagination');
    this._onPrevClick = this.handlePrevClick.bind(this);
    this._onNextClick = this.handleNextClick.bind(this);
    this._onSliderInit = (event) => {
      if (this.matchesSlider(event)) {
        this.startMirroring();
        this.update();
      }
    };
    this._onSliderChange = (event) => {
      if (this.matchesSlider(event)) {
        this.syncCloneClasses();
        this.update();
      }
    };
    this._onSliderDestroy = (event) => {
      if (this.matchesSlider(event)) {
        this.stopMirroring();
        this.update();
      }
    };
    this._onCloneClick = (event) => {
      const bullet = event.target.closest('.swiper-pagination-bullet');
      if (!bullet || !this.paginationEl?.contains(bullet)) return;
      if (this.paginationType !== 'bullets') return;
      const idx = Array.from(this.paginationEl.querySelectorAll('.swiper-pagination-bullet')).indexOf(bullet);
      const origBullets = this.originalBullets;
      if (idx > -1 && origBullets[idx]) {
        origBullets[idx].click();
      }
    };

    this._observer = null;
  }

  get sliderId() {
    return this._sliderId = this._sliderId || this.dataset.id
  }

  get sliderElement() {
    if (this._sliderElement && document.body.contains(this._sliderElement)) return this._sliderElement;
    this._sliderElement = document.querySelector(`theme-swiper[data-slider-id="${this.sliderId}"]`) || document.querySelector(`theme-swiper[data-id="${this.sliderId}"]`) || null;
    return this._sliderElement
  }

  get swiper() {
    return this.sliderElement?.swiper ?? null
  }

  get originalPaginationEl() {
    return this.swiper?.pagination?.el || this.sliderElement?.querySelector('.swiper-pagination') || null
  }

  get paginationType() {
    const t = this.swiper?.params?.pagination?.type;
    if (t) return t;
    const el = this.originalPaginationEl;
    if (!el) return 'bullets';
    if (el.classList.contains('swiper-pagination-fraction')) return 'fraction';
    if (el.classList.contains('swiper-pagination-progressbar')) return 'progressbar';
    return 'bullets';
  }

  get originalBullets() {
    const root = this.originalPaginationEl;
    return root ? Array.from(root.querySelectorAll('.swiper-pagination-bullet')) : [];
  }

  connectedCallback() {
    this.prevButton?.addEventListener('click', this._onPrevClick);
    this.nextButton?.addEventListener('click', this._onNextClick);
    this.paginationEl?.addEventListener('click', this._onCloneClick);
    document.addEventListener('slider:init', this._onSliderInit);
    document.addEventListener('slider:change', this._onSliderChange);
    document.addEventListener('slider:destroy', this._onSliderDestroy);
    if (this.swiper) this.startMirroring();
    this.update();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this._onPrevClick);
    this.nextButton?.removeEventListener('click', this._onNextClick);
    this.paginationEl?.removeEventListener('click', this._onCloneClick);
    document.removeEventListener('slider:init', this._onSliderInit);
    document.removeEventListener('slider:change', this._onSliderChange);
    document.removeEventListener('slider:destroy', this._onSliderDestroy);
    this.stopMirroring();
  }

  matchesSlider(event) {
    const idFromDetail = event?.detail?.id;
    const idFromTarget = event?.target?.dataset?.sliderId || event?.target?.dataset?.id;
    return (idFromDetail && idFromDetail == this.sliderId) || (idFromTarget && idFromTarget == this.sliderId);
  }

  handlePrevClick(event) {
    event.preventDefault();
    this.handleButtonsClick('previous');
  }

  handleNextClick(event) {
    event.preventDefault();
    this.handleButtonsClick('next');
  }

  handleButtonsClick(name = 'previous') {
    const swiper = this.sliderElement?.swiper;
    if (swiper) {
      (name == 'previous') ? swiper.slidePrev() : swiper.slideNext()
    } else {
      (name == 'previous') ? this.sliderElement?.prev?.click() : this.sliderElement?.next?.click()
    }
    this.update();
  }

  update() {
    const swiper = this.sliderElement?.swiper;

    if (!swiper) {
      this.prevButton?.setAttribute('disabled', 'true');
      this.nextButton?.setAttribute('disabled', 'true');
      this.prevButton?.setAttribute('aria-disabled', 'true');
      this.nextButton?.setAttribute('aria-disabled', 'true');
      return;
    }

    if (swiper.params.loop) {
      this.prevButton?.removeAttribute('disabled');
      this.nextButton?.removeAttribute('disabled');
      this.prevButton?.setAttribute('aria-disabled', 'false');
      this.nextButton?.setAttribute('aria-disabled', 'false');
    } else {
      if (swiper.isBeginning) {
        this.prevButton?.setAttribute('disabled', 'true');
        this.prevButton?.setAttribute('aria-disabled', 'true');
      } else {
        this.prevButton?.removeAttribute('disabled');
        this.prevButton?.setAttribute('aria-disabled', 'false');
      }

      if (swiper.isEnd) {
        this.nextButton?.toggleAttribute('disabled', 'true');
        this.nextButton?.setAttribute('aria-disabled', 'true');
      } else {
        this.nextButton?.removeAttribute('disabled');
        this.nextButton?.setAttribute('aria-disabled', 'false');
      }
    }
  }

  startMirroring() {
    const swiper = this.swiper;
    const orig = this.originalPaginationEl;
    if (!swiper || !orig || !this.paginationEl) return;
    try { swiper.pagination?.render?.(); swiper.pagination?.update?.(); } catch { }
    this.rebuildCloneFromOriginal();
    if (!this._observer) {
      this._observer = new MutationObserver((mutations) => {
        const needsRebuild = mutations.some(m => m.type === 'childList');
        if (needsRebuild) {
          this.rebuildCloneFromOriginal();
        } else {
          this.syncCloneClasses();
        }
      });
      this._observer.observe(orig, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'aria-current', 'aria-selected', 'aria-label']
      });
    }
  }

  stopMirroring() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  rebuildCloneFromOriginal() {
    const orig = this.originalPaginationEl;
    if (!orig || !this.paginationEl) return;
    this.paginationEl.className = `theme-swiper-controls__pagination ${orig.className}`.trim();
    this.paginationEl.innerHTML = orig.innerHTML;

    if (this.paginationType === 'bullets') {
      this.paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
        bullet.dataset.index = String(index);
        bullet.setAttribute('type', 'button');
      });
    } else if (this.paginationType === 'fraction') {
      this.paginationEl.setAttribute('aria-live', 'polite');
      this.paginationEl.setAttribute('aria-atomic', 'true');
    }
    this.syncCloneClasses();
  }

  syncCloneClasses() {
    const type = this.paginationType;
    const orig = this.originalPaginationEl;
    if (!orig || !this.paginationEl) return;

    if (type === 'bullets') {
      const origBullets = this.originalBullets;
      const cloneBullets = Array.from(this.paginationEl.querySelectorAll('.swiper-pagination-bullet'));
      const len = Math.min(origBullets.length, cloneBullets.length);
      for (let i = 0; i < len; i++) {
        const idx = cloneBullets[i].dataset.index;
        cloneBullets[i].className = origBullets[i].className;
        const ac = origBullets[i].getAttribute('aria-current');
        const as = origBullets[i].getAttribute('aria-selected');
        if (ac !== null) cloneBullets[i].setAttribute('aria-current', ac); else cloneBullets[i].removeAttribute('aria-current');
        if (as !== null) cloneBullets[i].setAttribute('aria-selected', as); else cloneBullets[i].removeAttribute('aria-selected');
        cloneBullets[i].dataset.index = idx ?? String(i);
      }
    } else if (type === 'fraction') {
      const oCur = orig.querySelector('.swiper-pagination-current');
      const oTot = orig.querySelector('.swiper-pagination-total');
      const cCur = this.paginationEl.querySelector('.swiper-pagination-current');
      const cTot = this.paginationEl.querySelector('.swiper-pagination-total');
      if (oCur && cCur) {
        cCur.textContent = oCur.textContent;
        cCur.className = oCur.className;
      }
      if (oTot && cTot) {
        cTot.textContent = oTot.textContent;
        cTot.className = oTot.className;
      }
    } else {
      this.paginationEl.innerHTML = orig.innerHTML;
    }
  }
}

customElements.define('theme-swiper-controls', ThemeSwiperControls);

class TabComponent extends HTMLElement {
  constructor() {
    super();
    this._onSliderChange = (event) => this.matchesSlider(event) && this.update();
  }

  get allItems() {
    return this._allItems = this._allItems || this.querySelectorAll('[data-filter]')
  }

  get sliderId() {
    return this._sliderId = this._sliderId || this.dataset.sliderId
  }

  get sliderElement() {
    if (this._sliderElement && document.body.contains(this._sliderElement)) return this._sliderElement;
    this._sliderElement = document.querySelector(`theme-swiper[data-slider-id="${this.sliderId}"]`) || document.querySelector(`theme-swiper[data-id="${this.sliderId}"]`) || null;

    return this._sliderElement;
  }

  get allContents() {
    return this._allContents = this._allContents || this.querySelectorAll('[data-tab-id]')
  }

  connectedCallback() {
    document.addEventListener('slider:change', this._onSliderChange);
    if (Shopify && Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const target = event.target;
        let targetData, button;
        if (target.classList.contains('swiper-slide')) {
          const tabElement = target.closest('[data-tab-id]');
          if (!tabElement) return;
          targetData = JSON.parse(tabElement.dataset.shopifyEditorBlock);
          button = this.querySelector(`[data-tab="#Tab-${targetData.domId}"]`);
          if (button) this.open(button, `Tab-${targetData.domId}`);
          const swiper = target.closest('theme-swiper');
          if (swiper) {
            swiper.addEventListener('slider:init', () => {
              swiper.setActiveSlideItem(target.dataset.index);
            }, { once: true })
          }
        } else {
          targetData = JSON.parse(target.dataset.shopifyEditorBlock);
          button = this.querySelector(`[data-tab="#Tab-${targetData.domId}"]`);
          if (button) this.open(button, `Tab-${targetData.domId}`);
        }
        [...this.allContents].forEach((content) => {
          this.load(content);
        });
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('slider:change', this._onSliderChange);
  }

  matchesSlider(event) {
    const idFromDetail = event?.detail?.id;
    const idFromTarget = event?.target?.dataset?.sliderId || event?.target?.dataset?.id;
    return (idFromDetail && idFromDetail == this.sliderId) || (idFromTarget && idFromTarget == this.sliderId);
  }

  filtering(value) {
    if (value == 'all') {
      Array.from(this.allItems).forEach((item) => item.classList.remove('hidden'));
    } else {
      const items = this.querySelectorAll(`[data-filter=${value}]`);
      Array.from(this.allItems).forEach((item) => item.classList.add('hidden'));
      Array.from(items).forEach((item, index) => {
        item.classList.remove('hidden')
        if (index == 0) item.querySelector('button')?.click();
      });
    }
  }

  open(button, tab) {
    if (button) this.setActiveElement(button);
    const _targetTab = button.closest('li');
    if (_targetTab.classList.contains('active')) return;
    const _currentTab = this.querySelector(`li.active`);
    const _currentTabContent = this.querySelector(`.tab__content-item.active`);
    const _targetTabContent = this.querySelector(`[data-tab-id="${tab}"]`);
    this.load(_targetTabContent);
    _currentTab.classList.remove('active');
    _currentTabContent.classList.remove('active');
    _targetTab.classList.add('active');
    _targetTabContent.classList.add('active');
  }

  load(tab) {
    if (!tab.getAttribute('loaded')) {
      const template = tab.querySelector(':scope template');
      if (!(template instanceof HTMLTemplateElement)) return;
      template.replaceWith(template.content.cloneNode(true));
      tab.setAttribute('loaded', true);
    }
  }

  update() {
    const swiper = this.sliderElement?.swiper;
    if (!swiper) return;
    const selectedElement = swiper.slides[swiper.activeIndex];
    const button = selectedElement.querySelector('button');
    if (button) this.setActiveElement(button);
    const tab = (button?.dataset?.tab ?? '').trim().replace(/^#/, '');
    const _targetTab = button.closest('li');
    if (_targetTab.classList.contains('active')) return;
    const _currentTab = this.querySelector(`li.active`);
    const _currentTabContent = this.querySelector(`.tab__content-item.active`);
    const _targetTabContent = this.querySelector(`[data-tab-id="${tab}"]`);
    this.load(_targetTabContent);
    _currentTab.classList.remove('active');
    _currentTabContent.classList.remove('active');
    _targetTab.classList.add('active');
    _targetTabContent.classList.add('active');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('tab-component', TabComponent);

class TemplateComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    const template = this.querySelector('.template');
    if (!template) return;
    if (!this.getAttribute('loaded')) {
      template.replaceWith(template.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
    }
  }
}

customElements.define('template-component', TemplateComponent);

class TextareaElement extends HTMLElement {
  constructor() {
    super();
    this.textarea = this.querySelector('textarea[maxlength]');
    this.counter = this.querySelector(':scope > span');
    this.updateRemainingCharacters = this.updateRemainingCharacters.bind(this);
  }

  connectedCallback() {
    if (!this.textarea || !this.counter) return;
    this.maxLength = Number(this.textarea.getAttribute('maxlength'));
    if (Number.isNaN(this.maxLength)) return;
    this.counter.setAttribute('aria-live', 'polite');
    this.textarea.addEventListener('input', this.updateRemainingCharacters);
    this.updateRemainingCharacters();
  }

  disconnectedCallback() {
    if (this.textarea) this.textarea.removeEventListener('input', this.updateRemainingCharacters);
  }

  updateRemainingCharacters() {
    const remainingCharacters = Math.max(this.maxLength - this.textarea.value.length, 0);
    this.counter.textContent = `${remainingCharacters} characters remaining`;
  }
}

customElements.define('textarea-element', TextareaElement);

class TrackingViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.expiresDate = parseInt(this.dataset.expiresDate) || 30;
    this.delay = parseInt(this.dataset.delaySeconds) || 0;
  }

  connectedCallback() {
    this.recordTimeout = setTimeout(() => {
      this.recordList({
        name: 'shopify_recently_viewed_products',
        expire: this.expiresDate,
        max: 10
      });
    }, this.delay * 1000);
  }

  disconnectedCallback() {
    if (this.recordTimeout) clearTimeout(this.recordTimeout);
  }

  setList(params, list) {
    if (this.dataset.productId !== '') {
      let productId = this.dataset.productId,
        position = list.indexOf(productId);
      if (position === -1) {
        list.unshift(productId);
        list = list.splice(0, params.max);
      } else {
        list.splice(position, 1);
        list.unshift(productId);
      }
      setCookie(params.name, list.join(' '), params.expire);
    }
  }

  recordList(params) {
    this.setList(params, readCookie(params.name));
  }
}

customElements.define('tracking-viewed-products', TrackingViewedProducts);

class VideoMedia extends HTMLElement {
  constructor() {
    super();
    this.onPosterClick = this.onPosterClick.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.toggleSound = this.toggleSound.bind(this);
  }

  connectedCallback() {
    if (!this.lazyLoad) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: 0
      });
    }

    this.posterElement?.addEventListener('click', this.onPosterClick);
    this.controlElement?.addEventListener('click', this.togglePlayPause);
    this.soundElement?.addEventListener('click', this.toggleSound);
  }

  disconnectedCallback() {
    this.posterElement?.removeEventListener('click', this.onPosterClick);
    this.controlElement?.removeEventListener('click', this.togglePlayPause);
    this.soundElement?.removeEventListener('click', this.toggleSound);
  }

  static get observedAttributes() {
    return ['playing', 'muted'];
  }

  get lazyLoad() {
    return this.hasAttribute('lazy-load')
  }

  get autoplay() {
    return this.hasAttribute('autoplay')
  }

  get playing() {
    return this.hasAttribute('playing')
  }

  get muted() {
    return this.hasAttribute('muted')
  }

  get posterElement() {
    return this.querySelector('[id^="Deferred-Poster-"]')
  }

  get controlElement() {
    return this.querySelector('.media__control-button')
  }

  get soundElement() {
    return this.querySelector('.media__sound-button')
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null
  }

  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.playerHandler(target, prop);
        };
      }
    });
  }

  init() {
    if (this.autoplay) if (!this.paused) this.play();
  }

  onPosterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
    this.updateControlButton(this.paused);
  }

  togglePlayPause(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
    this.updateControlButton(this.paused);
  }

  toggleSound(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.muted) {
      this.unmuted = true;
      this.soundOn();
    } else {
      this.unmuted = false;
      this.soundOff();
    }
    this.updateSoundButton(this.unmuted);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
        this.paused = false;
        this.updateControlButton(this.paused);
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
        this.paused = true;
        this.updateControlButton(this.paused);
      }
    } else if (name === 'muted') {
      this.updateSoundButton(newValue === null);
    }
  }

  play() {
    if (!this.playing) this.player.play();
  }

  pause() {
    if (this.playing) this.player.pause();
  }

  soundOff() {
    if (!this.muted) this.player.muted();
  }

  soundOn() {
    if (this.muted) this.player.unmuted();
  }

  updateControlButton(paused = false) {
    this.controlElement?.classList.toggle('is-pause', paused);
    this.controlElement?.classList.toggle('is-play', !paused);
  }

  updateSoundButton(unmuted = false) {
    this.soundElement?.classList.toggle('is-unmuted', unmuted);
    this.soundElement?.classList.toggle('is-muted', !unmuted);
  }

  playerTarget() {
    if (this.hasAttribute('host')) {
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1032px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';

        if (this.getAttribute('host') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }

          await onYouTubePromise;

          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                  this.setAttribute('muted', '');
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                  if (event.data === YT.PlayerState.ENDED) {
                    this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
                  }
                }

                if (player.isMuted()) {
                  this.setAttribute('muted', '');
                } else {
                  this.removeAttribute('muted');
                }
              }
            }
          });
        }

        if (this.getAttribute('host') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }

          const player = new Vimeo.Player(this.querySelector('iframe'));

          if (muteVideo) {
            player.setMuted(true);
            this.setAttribute('muted', '');
          }

          player.on('play', () => this.setAttribute('playing', ''));
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => {
            this.removeAttribute('playing');
            this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
          });
          player.on('volumechange', () => {
            if (player.muted) {
              this.setAttribute('muted', '');
            } else {
              this.removeAttribute('muted');
            }
          });

          resolve(player);
        }
      });
    } else {
      const templateElement = this.querySelector('template');
      if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', '');
      this.classList.remove('loading');

      const player = this.querySelector('video');
      if (player.muted) this.setAttribute('muted', '');

      player.setAttribute('playsinline', '');
      player.setAttribute('preload', 'auto');
      player.load();

      if (player.muted && player.autoplay) {
        const tryPlay = player.play();
        if (tryPlay && typeof tryPlay.catch === 'function') {
          tryPlay.catch(() => {
            this.setAttribute('suspended', '');
            // player.controls = true;
          });
        }
      }

      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });

      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) {
          this.removeAttribute('playing');
        }
      });

      player.addEventListener('volumechange', () => {
        if (player.muted) {
          this.setAttribute('muted', '');
        } else {
          this.removeAttribute('muted');
        }
      });

      const handleEnd = () => {
        this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
      };

      const setupLoopDetection = () => {
        const onTimeUpdate = () => {
          const duration = player.duration;
          if (!isNaN(duration) && player.currentTime >= duration - 0.3) {
            player.removeEventListener('timeupdate', onTimeUpdate);
            handleEnd();
          }
        };
        player.addEventListener('timeupdate', onTimeUpdate);
      };

      if (player.loop) {
        if (isNaN(player.duration)) {
          player.addEventListener('loadedmetadata', setupLoopDetection, { once: true });
        } else {
          setupLoopDetection();
        }
      } else {
        player.addEventListener('ended', handleEnd);
      }

      return player;
    }
  }

  playerHandler(target, prop) {
    if (this.getAttribute('host') === 'youtube') {
      if (prop === 'play') {
        target.playVideo();
      } else if (prop === 'pause') {
        target.pauseVideo();
      } else if (prop === 'muted') {
        target.mute();
        this.setAttribute('muted', '');
      } else if (prop === 'unmuted') {
        target.unMute();
        this.removeAttribute('muted');
      }
    } else {
      if (prop === 'play' && !this.hasAttribute('host')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
          }
        });
      } else if (prop === 'muted' && !this.hasAttribute('host')) {
        target.muted = true;
      } else if (prop === 'unmuted' && !this.hasAttribute('host')) {
        target.muted = false;
      } else {
        target[prop]();
      }
    }
  }
}

customElements.define('video-media', VideoMedia);

class VideoMediaControls extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  get targetId() {
    return this._targetId = this._targetId || this.dataset.id
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  set playing(value) {
    if (value) {
      this.setAttribute('playing', '');
    } else {
      this.removeAttribute('playing');
    }
  }

  get targetElement() {
    if (this._targetElement && document.body.contains(this._targetElement)) return this._targetElement;
    this._targetElement = document.getElementById(this.targetId);
    return this._targetElement;
  }

  connectedCallback() {
    // code here
  }

  disconnectedCallback() {
    // code here
  }

  onButtonClick() {
    const target = this.targetElement || document.querySelector(`[id=${this.targetId}]`);
    if (!target) return;

    const videoElements = target.querySelectorAll('video-media');
    if (!videoElements) return;

    Array.from(videoElements).forEach((videoElement) => {
      if (videoElement.playing) {
        videoElement.pause();
      } else {
        videoElement.play();
      }
    });

    this.playing = !this.playing;
    this.updateControlButton(this.playing);
  }

  updateControlButton(paused = false) {
    this.button?.classList.toggle('is-pause', !paused);
    this.button?.classList.toggle('is-play', paused);
  }
}

customElements.define('video-media-controls', VideoMediaControls);

(() => {
  if (window.__themeRuntimeInitialized) return;
  window.__themeRuntimeInitialized = true;
  window.__themeLoadedAssets ||= new Set();
  const ASSET_SELECTOR = '[data-theme-loader-assets]:not([data-theme-loader-processed])';

  function normalizeUrl(rawUrl) {
    if (!rawUrl) return '';

    try {
      return new URL(rawUrl, window.location.origin).href;
    } catch {
      return rawUrl;
    }
  }

  function isScriptAlreadyLoaded(url) {
    return Boolean(document.querySelector(`script[data-theme-loader-src="${url}"]`) || document.querySelector(`script[src="${url}"]`))
  }

  function appendScript(url) {
    const script = document.createElement('script');
    script.src = url;
    script.dataset.themeLoader = 'true';
    script.dataset.themeLoaderSrc = url;
    document.body.appendChild(script);
  }

  function themeLoadAssets(urls = []) {
    if (!Array.isArray(urls) || urls.length === 0) return;
    urls.forEach((rawUrl) => {
      const url = normalizeUrl(rawUrl);
      if (!url || window.__themeLoadedAssets.has(url)) return;
      if (isScriptAlreadyLoaded(url)) {
        window.__themeLoadedAssets.add(url);
        return;
      }
      window.__themeLoadedAssets.add(url);
      appendScript(url);
    });
  }

  function getAssetPayload(node) {
    const attrPayload = node.getAttribute('data-theme-loader-assets-json') || node.getAttribute('data-theme-loader-assets');
    const textPayload = (node.textContent || '').trim();
    const templatePayload = node instanceof HTMLTemplateElement && node.content ? (node.content.textContent || '').trim() : '';
    return (attrPayload && attrPayload.trim()) || textPayload || templatePayload || '';
  }

  function getAssetNodes(root) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const nodes = [];
    if (scope instanceof Element && scope.matches(ASSET_SELECTOR)) nodes.push(scope);
    nodes.push(...scope.querySelectorAll(ASSET_SELECTOR));
    return nodes
  }

  function themeCollectAndLoadAssets(root) {
    const nodes = getAssetNodes(root);
    if (!nodes.length) return;
    const urls = [];
    nodes.forEach((node) => {
      const payload = getAssetPayload(node);
      if (!payload) {
        node.dataset.themeLoaderProcessed = 'true';
        return
      }

      try {
        const parsed = JSON.parse(payload);
        if (Array.isArray(parsed)) {
          urls.push(...parsed);
        } else if (typeof parsed === 'string' && parsed) {
          urls.push(parsed);
        }
        node.dataset.themeLoaderProcessed = 'true';
        node.removeAttribute('data-theme-loader-error');
      } catch {
        node.dataset.themeLoaderError = 'json-parse';
      }
    });

    if (urls.length) themeLoadAssets(urls);
  }

  function runWhenIdle(callback, timeout = 1500) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout });
      return
    }
    window.setTimeout(callback, 1);
  }

  function applyBrowserClass() {
    const userAgent = navigator.userAgent.toLowerCase();
    let browser = 'unknown';
    if (/edg/.test(userAgent)) browser = 'edge';
    else if (/opr|opera/.test(userAgent)) browser = 'opera';
    else if (/firefox|fxios/.test(userAgent)) browser = 'firefox';
    else if (/chrome|crios|chromium/.test(userAgent) && !/edg|opr|opera/.test(userAgent)) browser = 'chrome';
    else if (/safari/.test(userAgent) && !/chrome|crios|chromium/.test(userAgent)) browser = 'safari';
    document.documentElement.classList.add(`browser-${browser}`);
  }

  function updateScrollbarWidth() {
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }

  function updateDeviceContextClass() {
    const userAgent = navigator.userAgent || '';
    const platform = navigator.userAgentData?.platform || navigator.platform || '';
    const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent);
    const isDesktopPlatform = /Win32|Win64|Windows|MacIntel|MacPPC|Linux x86_64|Linux armv/i.test(platform);
    const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const isNarrowViewport = window.innerWidth <= 1032;
    const isLikelyEmulatedMobile = isDesktopPlatform && isMobileUserAgent && isNarrowViewport;
    const isRealDevice = isMobileUserAgent && (hasTouch || hasCoarsePointer) && !isLikelyEmulatedMobile;
    const isResponsivePreview = isLikelyEmulatedMobile || (!isRealDevice && isNarrowViewport);
    document.documentElement.classList.toggle('is-device', isRealDevice);
    document.documentElement.classList.toggle('is-responsive', isResponsivePreview);
  }

  function flushThemeDeferQueue() {
    if (!Array.isArray(window.ThemeDefer) || window.ThemeDefer.length === 0) return;
    while (window.ThemeDefer.length) {
      const callback = window.ThemeDefer.shift();
      if (typeof callback === 'function') callback();
    }
  }

  function initDetailsAccessibility(root = document) {
    root.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
      summary.setAttribute('role', 'button');
      const details = summary.parentNode;
      const content = summary.nextElementSibling;
      summary.setAttribute('aria-expanded', details.hasAttribute('open'));
      if (content && content.id) summary.setAttribute('aria-controls', content.id);
      summary.addEventListener('click', (event) => {
        const el = event.currentTarget.closest('details');
        event.currentTarget.setAttribute('aria-expanded', !el.hasAttribute('open'));
      });
      if (summary.closest('menu-drawer')) return;
      details.addEventListener('keyup', onKeyUpEscape);
    });
  }

  function handleDomContentLoaded() {
    document.body.classList.add('page-load');
    document.dispatchEvent(new CustomEvent('page:loaded'));
    updateScrollbarWidth();
    updateDeviceContextClass();
    initDetailsAccessibility();
    runWhenIdle(() => {
      applyBrowserClass();
      flushThemeDeferQueue();
      themeCollectAndLoadAssets(document);
    });
  }

  const handleResize = (() => {
    let ticking = false;

    return () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        updateScrollbarWidth();
        updateDeviceContextClass();
      });
    };
  })();

  window.themeLoadAssets ||= themeLoadAssets;
  window.themeCollectAndLoadAssets ||= themeCollectAndLoadAssets;
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('page-unload');
  });
  window.addEventListener('DOMContentLoaded', handleDomContentLoaded);
  window.addEventListener('resize', handleResize);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.body.classList.remove('page-unload');
    }
  });
  document.addEventListener('shopify:section:load', (event) => {
    const target = event?.target || document;
    themeCollectAndLoadAssets(target);
    initDetailsAccessibility(target);
  });
})();


// optimize

  window.initLazyBackgroundImages = window.initLazyBackgroundImages || function(root) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const selector = '[data-lazy-bg="true"]';
    const elements = [];

    if (scope instanceof Element && scope.matches(selector)) elements.push(scope);
    elements.push(...scope.querySelectorAll(selector));
    elements.forEach(bindLazyBackground);
  };
